import '@theme/viewport-video';
import {i as te, g as ie, a as Y} from '@theme/card-image';
import {normalizeCardGalleryData} from '@theme/card-gallery-data';
const J = 750,
  se = 700,
  M = 1250,
  Q = 3e3,
  G = 250,
  ne = 300,
  galleryArrowContrastThreshold = 0.191,
  cardBadgeWhiteContrastLimit = 0.183,
  cardBadgeBlackContrastLimit = 0.199,
  galleryArrowSamplePixels = 12,
  galleryArrowSampleArea = 28,
  ae = 'combined-listing-card',
  f = {
    formInput: (S) => `[name="${S}"]`,
    cardImage: '.card__media img[data-model-image]',
    swatches: '.product-swatches',
    gallery: '[data-card-gallery]',
    galleryJson: '[data-card-gallery-json]',
    galleryPrev: '[data-gallery-prev]',
    galleryNext: '[data-gallery-next]',
    galleryProgress: '[data-gallery-progress]',
    galleryProgressTrack: '[data-gallery-progress-track]',
    sizeOverlayTrigger: '[data-size-overlay-trigger]',
    sizeOverlay: '[data-size-overlay]',
    sizeBackdrop: '[data-size-backdrop]',
    sizeGrid: '[data-size-grid]',
    sizeSheetHeader: '[data-size-sheet-header]',
    sizeSheetSwatches: '[data-size-sheet-swatches]',
    sizeOverlayClose: '[data-size-overlay-close]',
    sizeOption: '[data-size-option]',
    quickAddDirect: '[data-quick-add-direct]',
    quickAddMessage: '[data-quick-add-message]',
    quickAddError: '[data-quick-add-error]',
    cardBadge: '.card__inner .card__badge',
    cardWishlist: '.card__wishlist',
    cardGalleryAdd: '.card__gallery-add',
  },
  v = {
    swatchActive: 'active',
    sizeOptionDisabled: 'card__size-option--disabled',
    sizeOptionLowStock: 'card__size-option--low-stock',
    overlayOpen: 'card__size-overlay--open',
    backdropOpen: 'card__size-backdrop--open',
    cardSizeOverlayOpen: 'card-wrapper--size-overlay-open',
  };
function k(S) {
  return String(S ?? '')
    .trim()
    .toLowerCase();
}
let cardOverlayContrastObserver,
  cardOverlayContrastResizeObserver,
  quickAddQueue = Promise.resolve();
function getCardOverlayContrastResizeObserver() {
  return (
    cardOverlayContrastResizeObserver !== void 0 ||
      (cardOverlayContrastResizeObserver =
        typeof ResizeObserver == 'function'
          ? new ResizeObserver((S) => {
              const e = new Set();
              S.forEach((t) => {
                const i = t.target.closest('product-card');
                i && i.cardOverlayInView && e.add(i);
              }),
                e.forEach((t) => t.updateGalleryArrowContrast());
            })
          : null),
    cardOverlayContrastResizeObserver
  );
}
function getCardOverlayContrastObserver() {
  return (
    cardOverlayContrastObserver !== void 0 ||
      (cardOverlayContrastObserver =
        typeof IntersectionObserver == 'function'
          ? new IntersectionObserver(
              (S) => {
                const e = getCardOverlayContrastResizeObserver();
                S.forEach((t) => {
                  const i = t.target,
                    r = i.querySelector('.card__media');
                  (i.cardOverlayInView = t.isIntersecting),
                    t.isIntersecting
                      ? (r && (e == null || e.observe(r)), i.updateGalleryArrowContrast())
                      : (r && (e == null || e.unobserve(r)),
                        i.matches(':hover, :focus-within') || i.stopGalleryArrowContrastTracking());
                });
              },
              {rootMargin: '100px'}
            )
          : null),
    cardOverlayContrastObserver
  );
}
class oe extends HTMLElement {
  constructor() {
    super(), this.initialise();
  }
  initialise() {
    return this.initialised
      ? !0
      : ((this.form = this.form || this.querySelector('form')),
        this.form
          ? (this.initGallery(),
            this.initSwatches(),
            this.initSizeOverlay(),
            this.initQuickAdd(),
            (this.initialised = !0),
            !0)
          : !1);
  }
  connectedCallback() {
    const e = (this.connectionVersion || 0) + 1;
    this.connectionVersion = e;
    const t = () => {
      !this.isConnected ||
        this.connectionVersion !== e ||
        !this.initialise() ||
        this.connectionActive ||
        ((this.connectionActive = !0),
        this.galleryInitialised && document.addEventListener('plp:view-changed', this.onPlpViewChange),
        this.bindDesktopRollover(),
        this.bindGalleryArrowContrast(),
        this.configureGalleryInteractions(),
        this.initSheetSwipeToDismiss(),
        this.mobileMediaQuery &&
          this.onViewportChange &&
          (typeof this.mobileMediaQuery.addEventListener == 'function'
            ? this.mobileMediaQuery.addEventListener('change', this.onViewportChange)
            : this.mobileMediaQuery.addListener(this.onViewportChange)));
    };
    this.initialise() ? t() : queueMicrotask(t);
  }
  initGallery() {
    var t, i;
    if (
      this.galleryInitialised ||
      ((this.gallery = this.querySelector(f.gallery)),
      (this.cardImage = this.querySelector(f.cardImage)),
      (this.videoEl = this.querySelector('[data-card-video]')),
      (this.showingVideo = !!this.videoEl),
      this.toggleAttribute('data-card-gallery-video-active', this.showingVideo),
      !this.gallery || !this.cardImage)
    )
      return;
    const e = this.gallery.querySelector(f.galleryJson);
    if (e) {
      this.galleryInitialised = !0;
      try {
        this.galleryData = normalizeCardGalleryData(JSON.parse(e.textContent));
        this.rolloverSlide = this.galleryData.rollover || null;
        const r = this.galleryData.slidesByColor || {};
        (this.gallerySlidesByColor = {}),
          Object.keys(r).forEach((s) => {
            this.gallerySlidesByColor[k(s)] = r[s];
          });
      } catch {
        (this.galleryData = {defaultColor: '', rollover: null, slidesByColor: {}}),
          (this.rolloverSlide = null),
          (this.gallerySlidesByColor = {});
      }
      (this.galleryIndex = 0),
        (this.gallerySlides = []),
        (this.galleryProgress = this.gallery.querySelector(f.galleryProgress)),
        (this.onPlpViewChange = this.onPlpViewChange.bind(this)),
        (this.galleryPrevBtn = this.querySelector(f.galleryPrev)),
        (this.galleryNextBtn = this.querySelector(f.galleryNext)),
        (this.onGalleryPrevClick = (r) => {
          r.preventDefault(), r.stopPropagation(), this.stepGalleryOrVideo(-1);
        }),
        (this.onGalleryNextClick = (r) => {
          r.preventDefault(), r.stopPropagation(), this.stepGalleryOrVideo(1);
        }),
        (t = this.galleryPrevBtn) == null || t.addEventListener('click', this.onGalleryPrevClick),
        (i = this.galleryNextBtn) == null || i.addEventListener('click', this.onGalleryNextClick),
        this.galleryData.defaultColor && this.setGalleryForColor(this.galleryData.defaultColor),
        this.gallery.classList.toggle('card__gallery--item-view', this.cardImageView === 'item'),
        this.configureGalleryInteractions(),
        this.isConnected && document.addEventListener('plp:view-changed', this.onPlpViewChange);
    }
  }
  get isPlpToggleExcluded() {
    return te(this.dataset.productType);
  }
  get cardImageView() {
    return this.isPlpToggleExcluded ? 'model' : ie();
  }
  get galleryRenderView() {
    return 'model';
  }
  get isFiniteGallery() {
    return this.hasAttribute('data-card-gallery-finite');
  }
  configureGalleryInteractions() {
    var e;
    if (!this.gallery) return;
    const t = this.hasAttribute('data-card-gallery-no-drag');
    this.gallery.classList.add('card__gallery--js'),
      this.gallery.classList.toggle('card__gallery--no-swipe', t),
      (e = this._galleryDragCleanup) == null || e.call(this),
      (this._galleryDragCleanup = null),
      !t && !(this.getGalleryStepCount() < 2) && this.initGalleryDrag();
  }
  initGalleryDrag() {
    var K;
    if (this._galleryDragCleanup || !this.gallery) return;
    const e = 5,
      t = 30,
      i = 0.3,
      r = 4e3,
      s = this.querySelector('.card__media') || this.gallery,
      n = this.querySelector('.card__gallery-link'),
      a = (K = this.videoEl) == null ? void 0 : K.querySelector('a');
    let c = 0,
      l = 0,
      o = 0,
      h = null,
      y = !1,
      g = !1,
      d = !1,
      w = null,
      I = null,
      m = !1,
      b = null,
      C = null,
      P = null;
    const T = (u) => {
        var E;
        const p = s.clientWidth || ((E = this.cardImage) == null ? void 0 : E.clientWidth) || 0;
        return p ? Math.max(-p, Math.min(p, u)) : u;
      },
      O = (u) => {
        if (u && (u.target !== b || u.propertyName !== 'transform')) return;
        const p = b,
          E = C != null && C.outgoing === this.rolloverPreview;
        p &&
          (p.removeEventListener('transitionend', O),
          clearTimeout(P),
          (p.style.transition = ''),
          (p.style.transform = ''),
          C && this.restoreGalleryDragPreview(C),
          (b = null),
          (C = null),
          (P = null),
          E && this.suppressRolloverPreview()),
          this.removeAttribute('data-card-gallery-dragging');
      },
      _ = () => {
        O();
        const u = this._galleryDragPreview,
          p = (u == null ? void 0 : u.outgoing) || this.cardImage;
        if (!(p != null && p.style.transform)) {
          this.clearGalleryDragPreview(), this.removeAttribute('data-card-gallery-dragging');
          return;
        }
        if (
          ((b = p),
          (C = u),
          (this._galleryDragPreview = null),
          (p.style.transition = `transform ${G}ms ease`),
          (p.style.transform = ''),
          C)
        ) {
          const E = C.direction > 0 ? C.width : -C.width;
          (C.incoming.style.transition = `transform ${G}ms ease`), (C.incoming.style.transform = `translateX(${E}px)`);
        }
        p.addEventListener('transitionend', O), (P = window.setTimeout(O, G + 100));
      },
      L = () => {
        if (h !== null) {
          if (d)
            try {
              s.releasePointerCapture(h);
            } catch {}
          (h = null), (y = !1), (d = !1), clearTimeout(w), _();
        }
      },
      z = () => L(),
      B = () => {
        document.hidden && L();
      },
      $ = (u) => {
        if (this.getGalleryStepCount() < 2) return;
        if (!(u.isPrimary === !1 || (Number.isFinite(u.button) && u.button !== 0))) {
          if (u.target instanceof Element) {
            const p = u.target.closest('a, button, input, label, [data-size-overlay]');
            if (p && p !== n && p !== a) return;
          }
          h === null &&
            (O(),
            this.clearGalleryDragPreview(),
            this.finishGalleryAnimation(),
            u.stopPropagation(),
            (h = u.pointerId),
            (c = u.clientX),
            (l = u.clientY),
            (o = u.timeStamp),
            (y = !1),
            (g = !1),
            (d = !1),
            clearTimeout(w),
            (w = window.setTimeout(L, r)));
        }
      },
      H = (u) => {
        var V;
        if (u.pointerId !== h) return;
        if (this.getGalleryStepCount() < 2) {
          L();
          return;
        }
        u.stopPropagation();
        const p = u.clientX - c,
          E = u.clientY - l;
        if (
          ((Math.abs(p) > e || Math.abs(E) > e) && (g = !0),
          !y &&
            Math.abs(p) > Math.abs(E) &&
            Math.abs(p) > e &&
            ((y = !0),
            this.setAttribute('data-card-gallery-dragging', ''),
            p < 0 &&
            this.showingVideo &&
            this.rolloverPreview != null &&
            this.rolloverPreview.classList.contains('card__rollover-image--visible')
              ? (this.rolloverSuppressedForHover = !0)
              : p < 0 && !this.showingVideo && this.promoteRolloverToGalleryImage()
                ? void 0
                : this.suppressRolloverPreview(),
            (V = s.setPointerCapture) == null || V.call(s, u.pointerId),
            (d = !0)),
          y && this.cardImage)
        ) {
          const F = T(p);
          this.updateGalleryDragPreview(F < 0 ? 1 : -1, F);
        }
      },
      N = (u) => {
        if (u.pointerId !== h) return;
        u.stopPropagation(), clearTimeout(w), (h = null), (d = !1);
        const p = u.clientX - c,
          E = u.timeStamp - o,
          V = E > 0 ? Math.abs(p) / E : 0;
        if (!g) {
          (y = !1), this.removeAttribute('data-card-gallery-dragging');
          return;
        }
        (m = !0),
          clearTimeout(I),
          (I = window.setTimeout(() => {
            m = !1;
          })),
          y && (Math.abs(p) > t || (V > i && Math.abs(p) > e))
            ? (this.stepGalleryOrVideo(p < 0 ? 1 : -1, T(p)),
              this._pendingGalleryAnimation || this.removeAttribute('data-card-gallery-dragging'))
            : y
              ? _()
              : this.cardImage && (this.cardImage.style.transform = ''),
          (y = !1);
      },
      R = (u) => {
        u.pointerId === h && (u.stopPropagation(), L());
      },
      U = (u) => u.preventDefault(),
      x = (u) => {
        m && ((m = !1), clearTimeout(I), u.preventDefault(), u.stopPropagation());
      };
    let A = !1;
    const ee = (u) => {
        if (!(u instanceof Element)) return !1;
        const p = u.closest('a, button, input, label, [data-size-overlay]');
        return !!p && p !== n && p !== a;
      },
      W = (u) => {
        if (this.getGalleryStepCount() < 2) {
          A = !1;
          return;
        }
        (A = !ee(u.target)), A && u.stopPropagation();
      },
      X = (u) => {
        if (A && this.getGalleryStepCount() < 2) {
          A = !1;
          return;
        }
        A && u.stopPropagation();
      },
      D = (u) => {
        A && (u.stopPropagation(), (A = !1));
      };
    s.addEventListener('pointerdown', $),
      s.addEventListener('pointermove', H),
      s.addEventListener('pointerup', N),
      s.addEventListener('pointercancel', R),
      s.addEventListener('dragstart', U),
      s.addEventListener('touchstart', W),
      s.addEventListener('touchmove', X),
      s.addEventListener('touchend', D),
      s.addEventListener('touchcancel', D),
      n == null || n.addEventListener('click', x),
      a == null || a.addEventListener('click', x),
      window.addEventListener('blur', z),
      document.addEventListener('visibilitychange', B),
      (this._galleryDragCleanup = () => {
        if (h !== null && d)
          try {
            s.releasePointerCapture(h);
          } catch {}
        (h = null),
          (y = !1),
          (d = !1),
          (m = !1),
          clearTimeout(I),
          O(),
          this.removeAttribute('data-card-gallery-dragging'),
          this.clearGalleryDragPreview(),
          this.cardImage && ((this.cardImage.style.transition = ''), (this.cardImage.style.transform = '')),
          (A = !1),
          s.removeEventListener('pointerdown', $),
          s.removeEventListener('pointermove', H),
          s.removeEventListener('pointerup', N),
          s.removeEventListener('pointercancel', R),
          s.removeEventListener('dragstart', U),
          s.removeEventListener('touchstart', W),
          s.removeEventListener('touchmove', X),
          s.removeEventListener('touchend', D),
          s.removeEventListener('touchcancel', D),
          n == null || n.removeEventListener('click', x),
          a == null || a.removeEventListener('click', x),
          window.removeEventListener('blur', z),
          document.removeEventListener('visibilitychange', B),
          clearTimeout(w),
          (this._galleryDragCleanup = null);
      });
  }
  disconnectedCallback() {
    var e, t, i;
    (this.connectedSwatchRequestToken = (this.connectedSwatchRequestToken || 0) + 1),
      (e = this.connectedSwatchAbortController) == null || e.abort(),
      (this.connectedSwatchAbortController = null),
      this.clearConnectedSwatchBusyState(),
      (this.connectionActive = !1),
      (this.connectionVersion = (this.connectionVersion || 0) + 1),
      this.galleryInitialised && document.removeEventListener('plp:view-changed', this.onPlpViewChange),
      this.unbindDesktopRollover(),
      this.unbindGalleryArrowContrast(),
      this.removeRolloverPreview(),
      (t = this._galleryDragCleanup) == null || t.call(this),
      (this._galleryDragCleanup = null),
      (i = this._sheetSwipeCleanup) == null || i.call(this),
      (this._sheetSwipeCleanup = null),
      this.finishGalleryAnimation(),
      clearTimeout(this._videoRestoreTimer),
      this.closeSizeOverlay({immediate: !0, restoreFocus: !1, force: !0}),
      this.unbindOverlayDismissListeners(),
      this.unmountMobileOverlay(),
      this.releaseBackgroundIsolation(),
      clearTimeout(this.overlayCloseTimer),
      clearTimeout(this.overlayFinishTimer),
      cancelAnimationFrame(this.overlayOpenFrame),
      cancelAnimationFrame(this.overlayVisibleFrame),
      cancelAnimationFrame(this.overlayFocusFrame),
      this.mobileMediaQuery &&
        this.onViewportChange &&
        (typeof this.mobileMediaQuery.removeEventListener == 'function'
          ? this.mobileMediaQuery.removeEventListener('change', this.onViewportChange)
          : this.mobileMediaQuery.removeListener(this.onViewportChange));
  }
  bindDesktopRollover() {
    if (this._desktopRolloverBound || !this.hasAttribute('data-card-hover-image')) return;
    (this.desktopRolloverMediaQuery = window.matchMedia('(min-width: 990px) and (hover: hover)')),
      (this.onCardPointerEnter = () => {
        if (!this.isDesktopRolloverViewport()) return;
        (this.rolloverHoverActive = !0),
        (this.rolloverSuppressedForHover = !1),
          (this.rolloverPresentedSlide = null),
          this.resetDesktopGalleryToStart(),
          this.showRolloverPreview();
      }),
      (this.onCardPointerLeave = () => {
        if (!this.rolloverHoverActive) return;
        (this.rolloverHoverActive = !1),
          this.removeRolloverPreview(),
          (this.rolloverSuppressedForHover = !1),
          (this.rolloverPresentedSlide = null),
          this.resetDesktopGalleryToStart();
      }),
      (this.onDesktopRolloverViewportChange = (e) => {
        if (e.matches) return;
        this.removeRolloverPreview(),
          (this.rolloverHoverActive = !1),
          (this.rolloverSuppressedForHover = !1),
          (this.rolloverPresentedSlide = null),
          this.resetDesktopGalleryToStart({force: !0});
      }),
      this.addEventListener('pointerenter', this.onCardPointerEnter),
      this.addEventListener('pointerleave', this.onCardPointerLeave),
      typeof this.desktopRolloverMediaQuery.addEventListener == 'function'
        ? this.desktopRolloverMediaQuery.addEventListener('change', this.onDesktopRolloverViewportChange)
        : this.desktopRolloverMediaQuery.addListener(this.onDesktopRolloverViewportChange),
      (this._desktopRolloverBound = !0);
  }
  unbindDesktopRollover() {
    this._desktopRolloverBound &&
      (this.removeEventListener('pointerenter', this.onCardPointerEnter),
      this.removeEventListener('pointerleave', this.onCardPointerLeave),
      this.desktopRolloverMediaQuery &&
        this.onDesktopRolloverViewportChange &&
        (typeof this.desktopRolloverMediaQuery.removeEventListener == 'function'
          ? this.desktopRolloverMediaQuery.removeEventListener('change', this.onDesktopRolloverViewportChange)
          : this.desktopRolloverMediaQuery.removeListener(this.onDesktopRolloverViewportChange)),
      (this.desktopRolloverMediaQuery = null),
      (this._desktopRolloverBound = !1),
      (this.rolloverHoverActive = !1),
      (this.rolloverSuppressedForHover = !1),
      (this.rolloverPresentedSlide = null),
      this.resetDesktopGalleryToStart({force: !0}));
  }
  isDesktopRolloverViewport() {
    var e;
    return !!(
      ((e = this.desktopRolloverMediaQuery) == null ? void 0 : e.matches) ??
      window.matchMedia('(min-width: 990px) and (hover: hover)').matches
    );
  }
  bindGalleryArrowContrast() {
    if (this._galleryArrowContrastBound || !this.cardImage) return;
      (this.onGalleryArrowContrastEnter = () => this.updateGalleryArrowContrast()),
      (this.onGalleryArrowContrastFocus = () => this.updateGalleryArrowContrast()),
      (this.onGalleryArrowContrastLeave = () => {
        queueMicrotask(() => {
          this.cardOverlayInView || this.matches(':hover, :focus-within') || this.stopGalleryArrowContrastTracking();
        });
      }),
      (this.onGalleryArrowContrastBlur = () => {
        queueMicrotask(() => {
          this.cardOverlayInView || this.matches(':hover, :focus-within') || this.stopGalleryArrowContrastTracking();
        });
      }),
      this.addEventListener('pointerenter', this.onGalleryArrowContrastEnter),
      this.addEventListener('focusin', this.onGalleryArrowContrastFocus),
      this.addEventListener('pointerleave', this.onGalleryArrowContrastLeave),
      this.addEventListener('focusout', this.onGalleryArrowContrastBlur),
      this.watchCardWishlistState(),
      getCardOverlayContrastObserver()
        ? getCardOverlayContrastObserver().observe(this)
        : ((this.cardOverlayInView = !0), queueMicrotask(() => this.updateGalleryArrowContrast())),
      (this._galleryArrowContrastBound = !0);
  }
  unbindGalleryArrowContrast() {
    this._galleryArrowContrastBound &&
      (this.removeEventListener('pointerenter', this.onGalleryArrowContrastEnter),
      this.removeEventListener('focusin', this.onGalleryArrowContrastFocus),
      this.removeEventListener('pointerleave', this.onGalleryArrowContrastLeave),
      this.removeEventListener('focusout', this.onGalleryArrowContrastBlur),
      getCardOverlayContrastObserver() == null || getCardOverlayContrastObserver().unobserve(this),
      this.querySelector('.card__media') &&
        (getCardOverlayContrastResizeObserver() == null ||
          getCardOverlayContrastResizeObserver().unobserve(this.querySelector('.card__media'))),
      this.cardWishlistContrastObserver && this.cardWishlistContrastObserver.disconnect(),
      (this.cardWishlistContrastObserver = null),
      cancelAnimationFrame(this.cardWishlistContrastFrame),
      (this.cardWishlistContrastFrame = null),
      this.stopGalleryArrowContrastTracking(),
      (this.cardOverlayInView = !1),
      (this._galleryArrowContrastBound = !1));
  }
  watchCardWishlistState() {
    const e = this.querySelector(f.cardWishlist);
    if (!e || typeof MutationObserver != 'function') return;
    this.cardWishlistContrastObserver && this.cardWishlistContrastObserver.disconnect(),
      (this.cardWishlistContrastObserver = new MutationObserver(() => {
        cancelAnimationFrame(this.cardWishlistContrastFrame),
          (this.cardWishlistContrastFrame = requestAnimationFrame(() => {
            (this.cardWishlistContrastFrame = null),
              (this.cardOverlayInView || this.matches(':hover, :focus-within')) &&
                this.updateGalleryArrowContrast();
          }));
      })),
      this.cardWishlistContrastObserver.observe(e, {
        attributes: !0,
        attributeFilter: ['aria-pressed', 'class', 'hidden', 'rivo-ax-cloak', 'style'],
        childList: !0,
      });
  }
  stopGalleryArrowContrastTracking() {
    clearTimeout(this.galleryArrowVideoContrastTimer),
      (this.galleryArrowVideoContrastTimer = null),
      this.galleryArrowMediaReadyCleanup && this.galleryArrowMediaReadyCleanup(),
      (this.galleryArrowMediaReadyCleanup = null);
  }
  watchGalleryArrowMedia(e) {
    this.galleryArrowMediaReadyCleanup && this.galleryArrowMediaReadyCleanup();
    const t = e instanceof HTMLVideoElement ? 'loadeddata' : 'load',
      i = () => {
        this.galleryArrowMediaReadyCleanup && this.galleryArrowMediaReadyCleanup(),
          (this.galleryArrowMediaReadyCleanup = null),
          (this.cardOverlayInView || this.matches(':hover, :focus-within')) && this.updateGalleryArrowContrast();
      },
      r = () => {
        this.galleryArrowMediaReadyCleanup && this.galleryArrowMediaReadyCleanup(),
          (this.galleryArrowMediaReadyCleanup = null),
          this.setGalleryArrowColor(this.galleryPrevBtn, 'black', !0),
          this.setGalleryArrowColor(this.galleryNextBtn, 'black', !0),
          this.getCardOverlayContrastTargets().forEach((n) => this.setCardOverlayColor(n, 'black', !0));
      },
      s = () => {
        e.removeEventListener(t, i), e.removeEventListener('error', r);
      };
    e.addEventListener(t, i, {once: !0}),
      e.addEventListener('error', r, {once: !0}),
      (this.galleryArrowMediaReadyCleanup = s);
  }
  getVisibleGalleryArrowMedia() {
    if (this.rolloverPreview && this.rolloverHoverActive && !this.rolloverSuppressedForHover)
      return this.rolloverPreview;
    if (this.showingVideo && this.videoEl) return this.videoEl.querySelector('video') || this.cardImage;
    return this.cardImage;
  }
  setGalleryArrowColor(e, t, i = !1) {
    e &&
      ((e.dataset.galleryArrowColor = t === 'white' ? 'white' : 'black'),
      e.toggleAttribute('data-gallery-arrow-contrast-guard', i));
  }
  setCardOverlayColor(e, t, i = !1) {
    e &&
      ((e.dataset.cardOverlayColor = t === 'white' ? 'white' : 'black'),
      e.toggleAttribute('data-card-overlay-contrast-guard', i));
  }
  getCardOverlayContrastTargets() {
    return [this.querySelector(f.cardBadge), this.querySelector(f.cardWishlist), this.querySelector(f.cardGalleryAdd)].filter(
      (e) => e && !e.hidden && getComputedStyle(e).display !== 'none'
    );
  }
  getGalleryArrowBackdropColor(e) {
    const t = [];
    for (let i = e.parentElement; i; i = i.parentElement) {
      const r = getComputedStyle(i).backgroundColor.match(/[\d.]+/g);
      r &&
        r.length >= 3 &&
        t.push([Number(r[0]), Number(r[1]), Number(r[2]), r[3] === void 0 ? 1 : Number(r[3])]);
    }
    return t.reverse().reduce(
      (i, [r, s, n, a]) => [r * a + i[0] * (1 - a), s * a + i[1] * (1 - a), n * a + i[2] * (1 - a)],
      [255, 255, 255]
    );
  }
  getGalleryArrowLuminance(e, t, i = null) {
    const r = e instanceof HTMLVideoElement ? e.videoWidth : e.naturalWidth,
      s = e instanceof HTMLVideoElement ? e.videoHeight : e.naturalHeight,
      n =
        (Array.isArray(i) && i.length && this.querySelector('.card__media')?.getBoundingClientRect()) ||
        e.getBoundingClientRect();
    if (!r || !s || !n.width || !n.height) return null;
    const h = t instanceof Element ? t.getBoundingClientRect() : null,
      isArrowTarget = t === this.galleryPrevBtn || t === this.galleryNextBtn || t === 'prev' || t === 'next',
      y = h && h.width && h.height ? h.left - n.left + h.width / 2 : t === 'prev' || t === this.galleryPrevBtn ? 30 : n.width - 30,
      w = h && h.width && h.height ? h.top - n.top + h.height / 2 : n.height / 2,
      I = !isArrowTarget && h && h.width ? Math.max(16, Math.min(h.width, 96)) : galleryArrowSampleArea,
      V = !isArrowTarget && h && h.height ? Math.max(16, Math.min(h.height, 96)) : galleryArrowSampleArea;
    try {
      const m = this.galleryArrowCanvas || document.createElement('canvas');
      (this.galleryArrowCanvas = m),
        (m.width = galleryArrowSamplePixels),
        (m.height = galleryArrowSamplePixels);
      const b = m.getContext('2d', {willReadFrequently: !0});
      if (!b) return null;
      b.clearRect(0, 0, galleryArrowSamplePixels, galleryArrowSamplePixels),
        b.setTransform(
          galleryArrowSamplePixels / I,
          0,
          0,
          galleryArrowSamplePixels / V,
          (I / 2 - y) * (galleryArrowSamplePixels / I),
          (V / 2 - w) * (galleryArrowSamplePixels / V)
        );
      const C = (P) => {
        const T = P instanceof HTMLVideoElement ? P.videoWidth : P.naturalWidth,
          z = P instanceof HTMLVideoElement ? P.videoHeight : P.naturalHeight,
          H = P.getBoundingClientRect();
        if (!T || !z || !H.width || !H.height) return;
        const objectStyle = getComputedStyle(P),
          x =
            objectStyle.objectFit === 'contain'
              ? Math.min(H.width / T, H.height / z)
              : Math.max(H.width / T, H.height / z),
          A = T * x,
          R = z * x,
          [objectPositionX = '50%', objectPositionY = '50%'] = objectStyle.objectPosition.split(/\s+/),
          resolveObjectPosition = (value, freeSpace) => {
            if (value === 'left' || value === 'top') return 0;
            if (value === 'right' || value === 'bottom') return freeSpace;
            if (value === 'center') return freeSpace / 2;
            if (value.endsWith('%')) return (freeSpace * Number.parseFloat(value)) / 100;
            if (value.endsWith('px')) return Number.parseFloat(value);
            return freeSpace / 2;
          },
          U = H.left - n.left + resolveObjectPosition(objectPositionX, H.width - A),
          E = H.top - n.top + resolveObjectPosition(objectPositionY, H.height - R);
        b.drawImage(P, U, E, A, R);
      };
      Array.isArray(i) && i.length
        ? i.forEach((P) => C(P))
        : (e === this.rolloverPreview && this.cardImage && this.cardImage !== e && C(this.cardImage), C(e)),
        b.setTransform(1, 0, 0, 1, 0, 0);
      const P = b.getImageData(0, 0, galleryArrowSamplePixels, galleryArrowSamplePixels).data,
        T = [],
        z = (H) => (H <= 0.04045 ? H / 12.92 : ((H + 0.055) / 1.055) ** 2.4),
        H = this.getGalleryArrowBackdropColor(e);
      for (let x = 0; x < P.length; x += 4) {
        const A = P[x + 3] / 255,
          R = (P[x] * A + H[0] * (1 - A)) / 255,
          U = (P[x + 1] * A + H[1] * (1 - A)) / 255,
          E = (P[x + 2] * A + H[2] * (1 - A)) / 255;
        T.push(0.2126 * z(R) + 0.7152 * z(U) + 0.0722 * z(E));
      }
      return T.sort((x, A) => x - A)[Math.floor(T.length / 2)] ?? null;
    } catch {
      return null;
    }
  }
  updateGalleryArrowContrast(e = this.getVisibleGalleryArrowMedia()) {
    if (!this.isConnected) return;
    const t = this.matches(':hover, :focus-within'),
      i = this.isFiniteGallery && this.getGalleryStepCount() > 1 && this.isDesktopRolloverViewport() && t,
      r = !!this.cardOverlayInView || t;
    if (!i && !r) return;
    if (!e) {
      i && (this.setGalleryArrowColor(this.galleryPrevBtn, 'black', !0), this.setGalleryArrowColor(this.galleryNextBtn, 'black', !0)),
        r && this.getCardOverlayContrastTargets().forEach((s) => this.setCardOverlayColor(s, 'black', !0));
      return;
    }
    // A transparent rollover also needs its underlying image before sampling the composite.
    const pendingMedia =
      e === this.rolloverPreview && this.cardImage && (!this.cardImage.complete || !this.cardImage.naturalWidth)
        ? this.cardImage
        : e;
    if (
      (pendingMedia instanceof HTMLImageElement && (!pendingMedia.complete || !pendingMedia.naturalWidth)) ||
      (pendingMedia instanceof HTMLVideoElement && pendingMedia.readyState < 2)
    ) {
      i &&
        (this.setGalleryArrowColor(this.galleryPrevBtn, 'black', !0),
        this.setGalleryArrowColor(this.galleryNextBtn, 'black', !0)),
        r && this.getCardOverlayContrastTargets().forEach((s) => this.setCardOverlayColor(s, 'black', !0));
      this.watchGalleryArrowMedia(pendingMedia);
      return;
    }
    this.galleryArrowMediaReadyCleanup && this.galleryArrowMediaReadyCleanup(),
      (this.galleryArrowMediaReadyCleanup = null);
    const s = this._pendingGalleryAnimation,
      n = !!(s?.started && s.contrastLayers && s.contrastReference);
    if (n) this.updateGalleryTransitionContrast(s.contrastReference, s.contrastLayers);
    else {
      if (i) {
        const n = this.getGalleryArrowLuminance(e, this.galleryPrevBtn || 'prev'),
          a = this.getGalleryArrowLuminance(e, this.galleryNextBtn || 'next');
        this.setGalleryArrowColor(
          this.galleryPrevBtn,
          n !== null && n < galleryArrowContrastThreshold ? 'white' : 'black',
          n === null
        ),
          this.setGalleryArrowColor(
            this.galleryNextBtn,
            a !== null && a < galleryArrowContrastThreshold ? 'white' : 'black',
            a === null
          );
      }
      r && this.getCardOverlayContrastTargets().forEach((n) => this.updateCardOverlayTargetContrast(e, n));
    }
    clearTimeout(this.galleryArrowVideoContrastTimer),
      (this.galleryArrowVideoContrastTimer =
        e instanceof HTMLVideoElement
          ? window.setTimeout(() => this.updateGalleryArrowContrast(), 500)
          : null);
  }
  updateCardOverlayTargetContrast(e, t, i = null) {
    const r = this.getGalleryArrowLuminance(e, t, i),
      s = t.matches(f.cardBadge) && r !== null && r > cardBadgeWhiteContrastLimit && r < cardBadgeBlackContrastLimit;
    this.setCardOverlayColor(
      t,
      r === null ? t.dataset.cardOverlayColor || 'black' : r < galleryArrowContrastThreshold ? 'white' : 'black',
      r === null || s
    );
  }
  updateGalleryTransitionContrast(e, t) {
    if (!this.isConnected) return;
    const i = t.filter((r) => r instanceof HTMLImageElement || r instanceof HTMLVideoElement);
    if (!i.length) return;
    const r = this.matches(':hover, :focus-within'),
      s = this.isFiniteGallery && this.getGalleryStepCount() > 1 && this.isDesktopRolloverViewport() && r,
      n = !!this.cardOverlayInView || r;
    s &&
      [this.galleryPrevBtn, this.galleryNextBtn].forEach((a) => {
        if (!a || a.hidden || !a.getBoundingClientRect().width) return;
        const c = this.getGalleryArrowLuminance(e, a, i);
        this.setGalleryArrowColor(
          a,
          c === null ? a.dataset.galleryArrowColor || 'black' : c < galleryArrowContrastThreshold ? 'white' : 'black',
          c === null
        );
      }),
      n && this.getCardOverlayContrastTargets().forEach((a) => this.updateCardOverlayTargetContrast(e, a, i));
  }
  showRolloverPreview() {
    if (
      !this.rolloverHoverActive ||
      this.rolloverSuppressedForHover ||
      this.isSizeOverlayOpen() ||
      !this.rolloverSlide ||
      !this.cardImage ||
      !this.isDesktopRolloverViewport()
    )
      return;
    const e = this.querySelector('.card__media');
    if (!e) return;
    this.removeRolloverPreview();
    const t = this.createGalleryImage(this.rolloverSlide, this.cardImage),
      i = (this.rolloverPreviewToken || 0) + 1;
    (this.rolloverPreviewToken = i),
      Array.from(t.attributes).forEach((r) => {
        r.name.startsWith('data-') && t.removeAttribute(r.name);
      }),
      (t.alt = ''),
      t.setAttribute('aria-hidden', 'true'),
      t.classList.add('card__rollover-image'),
      e.appendChild(t),
      (this.rolloverPreview = t),
      this.getGalleryImageDecodePromise(t).then(
        () => {
          this.rolloverPreviewToken === i &&
          this.rolloverPreview === t &&
          this.rolloverHoverActive &&
          !this.rolloverSuppressedForHover &&
            ((this.rolloverPresentedSlide = this.rolloverSlide),
            this.applyGallerySlideOrder(),
            this.showingVideo && this.renderGallerySlide(0),
            this.updateGalleryControls(),
            this.updateGalleryProgress(),
            this.updateGalleryArrowContrast(t),
            (this.rolloverPreviewFrame = requestAnimationFrame(() => t.classList.add('card__rollover-image--visible'))));
        },
        () => {
          this.rolloverPreview === t && this.removeRolloverPreview();
        }
      );
  }
  removeRolloverPreview({fade: e = !1} = {}) {
    if (e && this.rolloverDismissedPreview) return;
    (this.rolloverPreviewToken = (this.rolloverPreviewToken || 0) + 1),
      cancelAnimationFrame(this.rolloverPreviewFrame),
      (this.rolloverPreviewFrame = null),
      clearTimeout(this.rolloverDismissTimer),
      this.rolloverDismissedPreview && this.rolloverDismissedPreview.remove(),
      (this.rolloverDismissedPreview = null);
    const t = this.rolloverPreview;
    if (!t) return;
    if (e && t.classList.contains('card__rollover-image--visible')) {
      t.classList.remove('card__rollover-image--visible'),
        (this.rolloverPreview = null),
        (this.rolloverDismissedPreview = t),
        (this.rolloverDismissTimer = window.setTimeout(() => {
          t.remove(),
            this.rolloverDismissedPreview === t && (this.rolloverDismissedPreview = null),
            (this.rolloverDismissTimer = null),
            this.updateGalleryArrowContrast();
        }, 220));
      return;
    }
    t.remove(), (this.rolloverPreview = null), this.updateGalleryArrowContrast();
  }
  suppressRolloverPreview({fade: e = !0} = {}) {
    this.rolloverHoverActive && (this.rolloverSuppressedForHover = !0), this.removeRolloverPreview({fade: e});
  }
  promoteRolloverToGalleryImage() {
    const e = this.rolloverPreview;
    if (
      !e ||
      !e.classList.contains('card__rollover-image--visible') ||
      !this.rolloverSlide ||
      !this.cardImage
    )
      return !1;
    const t = this.gallerySlides[this.galleryIndex];
    (this.rolloverPromotedImage = this.cardImage),
      (this.rolloverPromotedRestoreSlide = t || null),
      Y(
        this.cardImage,
        this.rolloverSlide.model,
        this.rolloverSlide.clearcut,
        this.rolloverSlide.width,
        this.galleryRenderView,
        this.rolloverSlide.height,
        this.rolloverSlide.clearcutWidth,
        this.rolloverSlide.clearcutHeight
      ),
      this.rolloverSlide.alt && (this.cardImage.alt = this.rolloverSlide.alt),
      (this.rolloverSuppressedForHover = !0),
      this.removeRolloverPreview();
    return !0;
  }
  slideRolloverToGalleryFromVideo(e, t = 0) {
    if (!this.videoEl || !this.gallery || !this.gallerySlides.length) return;
    (this.showingVideo = !1),
      (this.galleryIndex = 0),
      (this.videoEl.style.transition = 'none'),
      this.videoEl.classList.add('card__video--hidden'),
      this.gallery.classList.remove('card__gallery--video-hidden'),
      this.videoEl.offsetHeight,
      (this.videoEl.style.transition = ''),
      this.updateGalleryProgress(),
      this.slideGalleryAnimated(0, e, t, 0, {restoreVideoOnFailure: !0});
  }
  resetDesktopGalleryToStart({force: e = !1} = {}) {
    if (!this.isFiniteGallery || (!e && !this.isDesktopRolloverViewport()) || !this.gallery) return;
    this.finishGalleryAnimation(),
      this.clearGalleryDragPreview(),
      this.applyGallerySlideOrder(),
      this.videoEl
        ? ((this.showingVideo = !0),
          this.gallery.classList.add('card__gallery--video-hidden'),
          this.videoEl.classList.remove('card__video--hidden'))
        : ((this.showingVideo = !1), this.gallery.classList.remove('card__gallery--video-hidden')),
      this.renderGallerySlide(0),
      this.updateGalleryControls(),
      this.configureGalleryInteractions(),
      this.updateGalleryProgress();
  }
  onPlpViewChange() {
    var e;
    const t = this.rolloverHoverActive && this.isDesktopRolloverViewport() && this.matches(':hover');
    this.isPlpToggleExcluded ||
      (this.suppressRolloverPreview({fade: !1}),
      (this.rolloverPresentedSlide = null),
      this.applyGallerySlideOrder(),
      this.updateGalleryControls(),
      this.configureGalleryInteractions(),
      this.renderGallerySlide(0),
      this.updateGalleryProgress(),
      (e = this.gallery) == null || e.classList.toggle('card__gallery--item-view', this.cardImageView === 'item'),
      t && ((this.rolloverSuppressedForHover = !1), this.showRolloverPreview()));
  }
  stepGallery(e, t = 0) {
    var s;
    if (!((s = this.gallerySlides) != null && s.length)) return;
    this.finishGalleryAnimation();
    const i = this.gallerySlides.length,
      r = this.galleryIndex,
      n = this.isFiniteGallery
        ? Math.max(0, Math.min(i - 1, this.galleryIndex + e))
        : (this.galleryIndex + e + i) % i;
    if (n === r) {
      this.updateGalleryProgress();
      return;
    }
    (this.galleryIndex = n),
      this.updateGalleryProgress(),
      this.slideGalleryAnimated(this.galleryIndex, e, t, r);
  }
  stepGalleryOrVideo(e, t = 0) {
    var s;
    const r = e > 0 && this.promoteRolloverToGalleryImage();
    this.suppressRolloverPreview({fade: !r});
    if (this.showingVideo) {
      if (e > 0) {
        if (r) {
          this.slideRolloverToGalleryFromVideo(e, t);
          return;
        }
        const n = this.takeGalleryVideoDragPreview('video-to-image', e);
        n ? this.slideGalleryVideoBoundary(n, !1) : this.revealGalleryFromVideo();
      }
      return;
    }
    const i = ((s = this.gallerySlides) == null ? void 0 : s.length) || 0;
    if (
      this.videoEl &&
      (e < 0 && this.galleryIndex === 0 ? !0 : !this.isFiniteGallery && e > 0 && this.galleryIndex === i - 1)
    ) {
      const n = this.takeGalleryVideoDragPreview('image-to-video', e);
      n ? this.slideGalleryVideoBoundary(n, !0) : this.revealVideoFromGallery();
      return;
    }
    this.stepGallery(e, t);
  }
  takeGalleryVideoDragPreview(e, t) {
    const i = this._galleryDragPreview;
    return (i == null ? void 0 : i.kind) === e && i.direction === t
      ? ((this._galleryDragPreview = null), i)
      : (this.clearGalleryDragPreview(), null);
  }
  slideGalleryVideoBoundary(e, t) {
    var y;
    this.finishGalleryAnimation();
    const {incoming: i, outgoing: r, width: s} = e,
      n = (y = window.matchMedia) == null ? void 0 : y.call(window, '(prefers-reduced-motion: reduce)').matches,
      a = e.direction > 0 ? -s : s,
      c = t ? this.galleryIndex : e.index,
      l = {
        animationFrame: null,
        cancelled: !1,
        cleanup: null,
        cleanupTimer: null,
        decodeTimer: null,
        onTransitionEnd: null,
        started: !1,
      },
      o = (g) => {
        l.cancelled ||
          ((l.cancelled = !0),
          this.removeAttribute('data-card-gallery-transitioning'),
          this.removeAttribute('data-card-gallery-dragging'),
          clearTimeout(l.cleanupTimer),
          clearTimeout(l.decodeTimer),
          cancelAnimationFrame(l.animationFrame),
          i.removeEventListener('transitionend', l.onTransitionEnd),
          (this.showingVideo = g ? t : !t),
          (this.galleryIndex = c),
          this.gallery.classList.toggle('card__gallery--video-hidden', this.showingVideo),
          this.videoEl.classList.toggle('card__video--hidden', !this.showingVideo),
          this.restoreGalleryDragPreview(e),
          this.updateGalleryProgress(),
          this._pendingGalleryAnimation === l && (this._pendingGalleryAnimation = null));
      },
      h = () => {
        if (!(l.cancelled || this._pendingGalleryAnimation !== l)) {
          if (
            (clearTimeout(l.decodeTimer),
            (l.decodeTimer = null),
            (l.started = !0),
            this.setAttribute('data-card-gallery-transitioning', ''),
            (this.showingVideo = t),
            (this.galleryIndex = c),
            this.updateGalleryProgress(),
            n)
          ) {
            o(!0);
            return;
          }
          i.addEventListener('transitionend', l.onTransitionEnd),
            (l.animationFrame = requestAnimationFrame(() => {
              if (this._pendingGalleryAnimation !== l) return;
              const g = `transform ${M}ms cubic-bezier(0.22, 1, 0.36, 1)`;
              (i.style.transition = g),
                (r.style.transition = g),
                (i.style.transform = 'translateX(0)'),
                (r.style.transform = `translateX(${a}px)`);
            })),
            (l.cleanupTimer = window.setTimeout(() => o(!0), M + 100));
        }
      };
    (l.cleanup = () => o(l.started)),
      (l.onTransitionEnd = (g) => {
        g.target !== i || g.propertyName !== 'transform' || o(!0);
      }),
      (this._pendingGalleryAnimation = l),
      e.ready || !e.decodePromise
        ? h()
        : ((l.decodeTimer = window.setTimeout(() => o(!1), Q)), e.decodePromise.then(h).catch(() => o(!1)));
  }
  revealGalleryFromVideo() {
    !this.videoEl ||
      !this.gallery ||
      ((this.showingVideo = !1),
      this.videoEl.classList.add('card__video--hidden'),
      this.gallery.classList.remove('card__gallery--video-hidden'),
      (this.galleryIndex = 0),
      this.renderGallerySlide(0),
      this.updateGalleryProgress());
  }
  revealVideoFromGallery() {
    !this.videoEl ||
      !this.gallery ||
      (this.cardImage && ((this.cardImage.style.transition = ''), (this.cardImage.style.transform = '')),
      (this.showingVideo = !0),
      this.gallery.classList.add('card__gallery--video-hidden'),
      this.videoEl.classList.remove('card__video--hidden'),
      this.updateGalleryProgress());
  }
  createGalleryImage(e, t) {
    // Fetch additional imagery only when hover, navigation or a drag requests it.
    const i = t.cloneNode(!1);
    return (
      i.removeAttribute('src'),
      i.removeAttribute('srcset'),
      i.removeAttribute('style'),
      i.classList.remove('gallery-slide-transition'),
      (i.draggable = !1),
      (i.loading = 'eager'),
      'fetchPriority' in i && (i.fetchPriority = 'high'),
      Y(i, e.model, e.clearcut, e.width, this.galleryRenderView, e.height, e.clearcutWidth, e.clearcutHeight),
      e.alt && (i.alt = e.alt),
      i
    );
  }
  getGalleryImageDecodePromise(e) {
    if (typeof e.decode == 'function')
      try {
        return Promise.resolve(e.decode());
      } catch (t) {
        return Promise.reject(t);
      }
    return e.complete && e.naturalWidth > 0
      ? Promise.resolve()
      : new Promise((t, i) => {
          const r = () => {
              e.removeEventListener('load', s), e.removeEventListener('error', n);
            },
            s = () => {
              r(), t();
            },
            n = () => {
              r(), i(new Error('Gallery image failed to load'));
            };
          e.addEventListener('load', s), e.addEventListener('error', n);
        });
  }
  getGalleryDragTarget(e) {
    var r;
    if (!((r = this.gallerySlides) != null && r.length)) return null;
    const t = this.gallerySlides.length;
    if (this.showingVideo) return e > 0 ? {index: 0, kind: 'video-to-image'} : null;
    if (this.videoEl && e < 0 && this.galleryIndex === 0) return {index: -1, kind: 'image-to-video'};
    if (this.videoEl && !this.isFiniteGallery && e > 0 && this.galleryIndex === t - 1)
      return {index: -1, kind: 'image-to-video'};
    if (this.isFiniteGallery && (this.galleryIndex + e < 0 || this.galleryIndex + e >= t)) return null;
    const i = (this.galleryIndex + e + t) % t;
    return {index: i, kind: 'image', slide: this.gallerySlides[i]};
  }
  updateGalleryDragPreview(e, t) {
    var h, y;
    if (!this.cardImage) return;
    const i = this.getGalleryDragTarget(e);
    if (!i) {
      this.clearGalleryDragPreview();
      return;
    }
    const r =
        i.kind === 'video-to-image' &&
        this.rolloverPreview != null &&
        this.rolloverPreview.classList.contains('card__rollover-image--visible')
          ? this.rolloverPreview
          : i.kind === 'video-to-image'
            ? this.videoEl
            : this.cardImage,
      s = this.cardImage.parentElement;
    if (!r || !s) return;
    const n =
        s.clientWidth ||
        ((h = this.querySelector('.card__media')) == null ? void 0 : h.clientWidth) ||
        this.cardImage.clientWidth ||
        r.clientWidth ||
        0,
      a = n || 1,
      c = n ? Math.max(-n, Math.min(n, t)) : t,
      l = (y = window.matchMedia) == null ? void 0 : y.call(window, '(prefers-reduced-motion: reduce)').matches;
    let o = this._galleryDragPreview;
    if (
      (o &&
        (o.direction !== e || o.index !== i.index || o.kind !== i.kind || o.outgoing !== r) &&
        (this.clearGalleryDragPreview(), (o = null)),
      !o && i.kind === 'image')
    ) {
      const g = this.createGalleryImage(i.slide, r),
        d = e > 0 ? a : -a;
      (g.style.transition = 'none'),
        (g.style.transform = `translateX(${d}px)`),
        s.appendChild(g),
        (o = {
          decodePromise: null,
          direction: e,
          incoming: g,
          index: i.index,
          kind: i.kind,
          latestOffset: c,
          outgoing: r,
          ready: !1,
          width: a,
        }),
        (this._galleryDragPreview = o),
        (o.decodePromise = this.getGalleryImageDecodePromise(g)),
        o.decodePromise.then(
          () => {
            (o.ready = !0), this._galleryDragPreview === o && !l && this.positionGalleryDragPreview(o);
          },
          () => {
            o.failed = !0;
          }
        );
    } else if (!o && i.kind === 'image-to-video') {
      const g = this.videoEl;
      clearTimeout(this._videoRestoreTimer),
        (g.style.opacity = '1'),
        (g.style.pointerEvents = 'none'),
        (g.style.transition = 'none'),
        (g.style.transform = `translateX(${-a}px)`),
        (o = {
          direction: e,
          incoming: g,
          index: i.index,
          kind: i.kind,
          latestOffset: c,
          outgoing: r,
          ready: !0,
          width: a,
        }),
        (this._galleryDragPreview = o);
    } else if (!o && i.kind === 'video-to-image') {
      const g = this.cardImage,
        d = g.parentElement,
        w = r !== this.videoEl;
      w &&
        ((this.videoEl.style.transition = 'none'),
        this.videoEl.classList.add('card__video--hidden'),
        this.videoEl.offsetHeight);
      (d.style.opacity = '1'),
        (d.style.transition = 'none'),
        (d.style.visibility = 'visible'),
        (g.style.transition = 'none'),
        (g.style.transform = `translateX(${a}px)`),
        (o = {
          decodePromise: null,
          direction: e,
          incoming: g,
          incomingSurface: d,
          index: i.index,
          kind: i.kind,
          latestOffset: c,
          outgoing: r,
          ready: !1,
          rolloverOutgoing: w,
          width: a,
        }),
        (this._galleryDragPreview = o),
        (o.decodePromise = this.getGalleryImageDecodePromise(g)),
        o.decodePromise.then(
          () => {
            (o.ready = !0), this._galleryDragPreview === o && !l && this.positionGalleryDragPreview(o);
          },
          () => {
            o.failed = !0;
          }
        );
    }
    o
      ? ((o.latestOffset = c), o.ready && !l && this.positionGalleryDragPreview(o))
      : l || ((r.style.transition = 'none'), (r.style.transform = c ? `translateX(${c}px)` : ''));
  }
  positionGalleryDragPreview(e) {
    if (!e.outgoing.isConnected || !e.incoming.isConnected) return;
    const t = e.direction > 0 ? e.width : -e.width;
    (e.outgoing.style.transition = 'none'),
      (e.outgoing.style.transform = e.latestOffset ? `translateX(${e.latestOffset}px)` : ''),
      (e.incoming.style.transition = 'none'),
      (e.incoming.style.transform = `translateX(${t + e.latestOffset}px)`);
  }
  restoreGalleryDragPreview(e, {resetOutgoing: t = !0} = {}) {
    if (
      ((e.incoming.style.transition = ''),
      (e.incoming.style.transform = ''),
      e.kind === 'image'
        ? e.incoming.remove()
        : e.kind === 'image-to-video'
          ? ((e.incoming.style.opacity = ''), (e.incoming.style.pointerEvents = ''))
          : e.kind === 'video-to-image' &&
            ((e.incomingSurface.style.opacity = ''),
            (e.incomingSurface.style.transition = ''),
            (e.incomingSurface.style.visibility = ''),
            e.rolloverOutgoing &&
              this.showingVideo &&
              ((this.videoEl.style.transition = 'none'),
              this.videoEl.classList.remove('card__video--hidden'),
              this.videoEl.offsetHeight,
              (this.videoEl.style.transition = ''))),
      !t || !e.outgoing.isConnected)
    )
      return;
    const i = e.outgoing;
    if (!(e.kind === 'video-to-image' && i.classList.contains('card__video--hidden'))) {
      (i.style.transition = ''), (i.style.transform = '');
      return;
    }
    clearTimeout(this._videoRestoreTimer),
      (this._videoRestoreTimer = window.setTimeout(() => {
        i.classList.contains('card__video--hidden') && ((i.style.transition = ''), (i.style.transform = ''));
      }, ne + 50));
  }
  clearGalleryDragPreview({resetOutgoing: e = !0} = {}) {
    const t = this._galleryDragPreview;
    t && (this.restoreGalleryDragPreview(t, {resetOutgoing: e}), (this._galleryDragPreview = null));
  }
  takeGalleryDragPreview(e, t, i) {
    const r = this._galleryDragPreview;
    return (r == null ? void 0 : r.kind) === 'image' && r.index === e && r.direction === t && r.outgoing === i
      ? ((this._galleryDragPreview = null), r)
      : (this.clearGalleryDragPreview(), null);
  }
  slideGalleryAnimated(e, t, i = 0, r = this.galleryIndex, {restoreVideoOnFailure: s = !1} = {}) {
    var O, _, L;
    const n = (O = this.gallerySlides) == null ? void 0 : O[e];
    if (!n || !this.cardImage) {
      s && this.restoreVideoAfterGalleryFailure();
      return;
    }
    const a = (_ = window.matchMedia) == null ? void 0 : _.call(window, '(prefers-reduced-motion: reduce)').matches,
      c = this.cardImage.parentElement;
    if (!c) {
      this.clearGalleryDragPreview(),
        (this.cardImage.style.transition = ''),
        (this.cardImage.style.transform = ''),
        this.renderGallerySlide(e),
        s ? this.restoreVideoAfterGalleryFailure() : this.updateGalleryProgress();
      return;
    }
    this.finishGalleryAnimation();
    const l =
        c.clientWidth ||
        ((L = this.querySelector('.card__media')) == null ? void 0 : L.clientWidth) ||
        this.cardImage.clientWidth ||
        0,
      o = l || 1,
      h = l ? Math.max(-l, Math.min(l, i)) : i,
      y = this.cardImage,
      g = this.takeGalleryDragPreview(e, t, y);
    const R = this.rolloverPromotedImage === y,
      U = this.rolloverPromotedRestoreSlide;
    (this.rolloverPromotedImage = null), (this.rolloverPromotedRestoreSlide = null);
    y.classList.remove('gallery-slide-transition'), (y.style.transition = 'none');
    const d = (g != null && g.ready) || R ? h : 0;
    y.style.transform = d ? `translateX(${d}px)` : '';
    const w = (g == null ? void 0 : g.incoming) || this.createGalleryImage(n, y),
      I = t > 0 ? o : -o,
      V = t > 0 ? -o : o,
      m = {
        animationFrame: null,
        cancelled: !1,
        cleanup: null,
        cleanupTimer: null,
        contrastAnimationFrame: null,
        contrastLayers: [y, w],
        contrastReference: w,
        contrastSampleTime: 0,
        decodeTimer: null,
        newImg: w,
        onError: null,
        onLoad: null,
        onRecoveryTransitionEnd: null,
        onTransitionEnd: null,
        previousIndex: r,
        restoreSlide: R ? U : null,
        restoreVideoOnFailure: s,
        started: !1,
        visibleLiveOffsetPx: d,
      },
      b = () => {
        (m.cancelled = !0),
          this.removeAttribute('data-card-gallery-transitioning'),
          this.removeAttribute('data-card-gallery-dragging'),
          clearTimeout(m.cleanupTimer),
          clearTimeout(m.decodeTimer),
          cancelAnimationFrame(m.animationFrame),
          cancelAnimationFrame(m.contrastAnimationFrame),
          w.removeEventListener('transitionend', m.onTransitionEnd),
          m.onRecoveryTransitionEnd && y.removeEventListener('transitionend', m.onRecoveryTransitionEnd),
          m.onLoad && w.removeEventListener('load', m.onLoad),
          m.onError && w.removeEventListener('error', m.onError),
          m.started
            ? (y.remove(),
              w.classList.remove('gallery-slide-transition'),
              (w.style.transform = ''),
              (this.cardImage = w))
            : (w.remove(),
              (this.cardImage = y),
              (y.style.transition = ''),
              (y.style.transform = ''),
              m.restoreSlide &&
                (Y(
                  y,
                  m.restoreSlide.model,
                  m.restoreSlide.clearcut,
                  m.restoreSlide.width,
                  this.galleryRenderView,
                  m.restoreSlide.height,
                  m.restoreSlide.clearcutWidth,
                  m.restoreSlide.clearcutHeight
                ),
                m.restoreSlide.alt && (y.alt = m.restoreSlide.alt)),
              m.restoreVideoOnFailure && this.restoreVideoAfterGalleryFailure(),
              this._pendingGalleryAnimation === m &&
                ((this.galleryIndex = m.previousIndex), this.updateGalleryProgress())),
          this._pendingGalleryAnimation === m && (this._pendingGalleryAnimation = null),
          this.updateGalleryArrowContrast();
      },
      C = (z) => {
        z.target !== w || z.propertyName !== 'transform' || b();
      },
      A = (z) => {
        if (m.cancelled || this._pendingGalleryAnimation !== m) return;
        (this.cardOverlayInView || this.matches(':hover, :focus-within')) &&
          (!m.contrastSampleTime || z - m.contrastSampleTime >= 50) &&
          ((m.contrastSampleTime = z), this.updateGalleryTransitionContrast(w, [y, w])),
          (m.contrastAnimationFrame = requestAnimationFrame(A));
      };
    (m.cleanup = b), (m.onTransitionEnd = C), (this._pendingGalleryAnimation = m);
    const P = () => {
        if (!(m.cancelled || m.started || this._pendingGalleryAnimation !== m)) {
          if (!m.visibleLiveOffsetPx) {
            b();
            return;
          }
          (m.cancelled = !0),
            clearTimeout(m.decodeTimer),
            (m.decodeTimer = null),
            (y.style.transition = `transform ${G}ms ease`),
            (y.style.transform = ''),
            w.isConnected &&
              ((w.style.transition = `transform ${G}ms ease`), (w.style.transform = `translateX(${I}px)`)),
            (m.onRecoveryTransitionEnd = (z) => {
              z.target !== y || z.propertyName !== 'transform' || b();
            }),
            y.addEventListener('transitionend', m.onRecoveryTransitionEnd),
            (m.cleanupTimer = window.setTimeout(b, G + 100));
        }
      },
      T = () => {
        if (!(m.cancelled || this._pendingGalleryAnimation !== m)) {
          if (
            (clearTimeout(m.decodeTimer),
            (m.decodeTimer = null),
            (m.started = !0),
            this.removeAttribute('data-card-gallery-dragging'),
            this.setAttribute('data-card-gallery-transitioning', ''),
            (y.style.transition = 'none'),
            (y.style.transform = h ? `translateX(${h}px)` : ''),
            (w.style.transition = 'none'),
            (w.style.transform = `translateX(${I + h}px)`),
            w.isConnected || c.appendChild(w),
            (this.cardImage = w),
            this.updateGalleryProgress(),
            a)
          ) {
            b();
            return;
          }
          w.addEventListener('transitionend', C),
            (m.animationFrame = requestAnimationFrame(() => {
              this._pendingGalleryAnimation === m &&
                (y.classList.add('gallery-slide-transition'),
                w.classList.add('gallery-slide-transition'),
                (y.style.transition = ''),
                (w.style.transition = ''),
                (y.style.transform = `translateX(${V}px)`),
                (w.style.transform = 'translateX(0)'),
                (m.contrastAnimationFrame = requestAnimationFrame(A)));
            })),
            (m.cleanupTimer = window.setTimeout(b, M + 100));
        }
      };
    (m.decodeTimer = window.setTimeout(P, Q)),
      g != null && g.decodePromise
        ? g.decodePromise.then(T).catch(P)
        : typeof w.decode == 'function'
          ? w.decode().then(T).catch(P)
          : w.complete && w.naturalWidth > 0
            ? T()
            : ((m.onLoad = T),
              (m.onError = P),
              w.addEventListener('load', m.onLoad, {once: !0}),
              w.addEventListener('error', m.onError, {once: !0}));
  }
  restoreVideoAfterGalleryFailure() {
    if (!this.videoEl || !this.gallery) return;
    (this.showingVideo = !0),
      (this.galleryIndex = 0),
      (this.videoEl.style.transition = 'none'),
      this.gallery.classList.add('card__gallery--video-hidden'),
      this.videoEl.classList.remove('card__video--hidden'),
      this.videoEl.offsetHeight,
      (this.videoEl.style.transition = ''),
      this.updateGalleryProgress();
  }
  finishGalleryAnimation() {
    const e = this._pendingGalleryAnimation;
    e && e.cleanup();
  }
  renderGallerySlide(e) {
    var i;
    const t = (i = this.gallerySlides) == null ? void 0 : i[e];
    !t ||
      !this.cardImage ||
      (this.clearGalleryDragPreview(),
      this.finishGalleryAnimation(),
      (this.rolloverPromotedImage = null),
      (this.rolloverPromotedRestoreSlide = null),
      Y(
        this.cardImage,
        t.model,
        t.clearcut,
        t.width,
        this.galleryRenderView,
        t.height,
        t.clearcutWidth,
        t.clearcutHeight
      ),
      t.alt && (this.cardImage.alt = t.alt),
      this.updateGalleryArrowContrast(this.cardImage));
  }
  updateGalleryProgress() {
    const e = this.showingVideo ? 0 : this.galleryIndex + (this.videoEl ? 1 : 0);
    this.toggleAttribute('data-card-gallery-video-active', !!this.showingVideo),
      this.galleryProgress && this.galleryProgress.style.setProperty('--gallery-index', String(e)),
      this.updateGalleryNavigation(),
      this.updateGalleryArrowContrast();
  }
  setGalleryForColor(e) {
    var r;
    const t = this.rolloverHoverActive && this.isDesktopRolloverViewport() && this.matches(':hover');
    this.suppressRolloverPreview({fade: !1}), (this.rolloverPresentedSlide = null), this.finishGalleryAnimation();
    const i = ((r = this.gallerySlidesByColor) == null ? void 0 : r[k(e)]) || [];
    if (!i.length) {
      (this.canonicalGallerySlides = []),
        (this.gallerySlides = []),
        (this.galleryIndex = 0),
        this.updateGalleryControls(),
        this.configureGalleryInteractions();
      return;
    }
    const s = i[i.length - 1].model;
    (this.canonicalGallerySlides = i.map((n) => ({...n, clearcut: n.clearcut || s}))),
      this.applyGallerySlideOrder(),
      this.updateGalleryControls(),
      this.configureGalleryInteractions(),
      this.renderGallerySlide(0),
      t && ((this.rolloverSuppressedForHover = !1), this.showRolloverPreview());
  }
  applyGallerySlideOrder() {
    const e = this.canonicalGallerySlides || [],
      t = e.findIndex((i) => i.model === i.clearcut);
    let i;
    if (((this.itemSlideIndex = t), this.cardImageView !== 'item')) i = e;
    else if (t >= 0) i = t > 0 ? [...e.slice(t), ...e.slice(0, t)] : e;
    else {
      const r = this.buildGhostSlide(e);
      i = r ? [r, ...e] : e;
    }
    (this.gallerySlides = this.getDesktopHoverGallerySlides(i)), (this.galleryIndex = 0);
  }
  getDesktopHoverGallerySlides(e) {
    if (
      !this.rolloverHoverActive ||
      !this.isFiniteGallery ||
      !this.isDesktopRolloverViewport() ||
      !this.rolloverPresentedSlide
    )
      return e;
    const t = this.rolloverPresentedSlide,
      i =
        t.id == null
          ? -1
          : e.findIndex((r, s) => (s > 0 || this.showingVideo) && r.id != null && String(r.id) === String(t.id)),
      r = i >= 0 ? i : e.findIndex((i, r) => (r > 0 || this.showingVideo) && i.model === t.model);
    return r < 0 ? e : [...e.slice(0, r), ...e.slice(r + 1)];
  }
  buildGhostSlide(e) {
    const t = e[0],
      i = t == null ? void 0 : t.clearcut;
    return i
      ? {
          model: i,
          clearcut: i,
          width: t.clearcutWidth || t.width,
          height: t.clearcutHeight || t.height,
          clearcutWidth: t.clearcutWidth,
          clearcutHeight: t.clearcutHeight,
          alt: t.alt,
        }
      : null;
  }
  updateGalleryControls() {
    if (!this.gallery) return;
    const e = this.getGalleryStepCount();
    this.connectionActive && this.bindGalleryArrowContrast(),
      this.gallery.classList.toggle('card__gallery--multiple', e > 1);
    const t = this.gallery.querySelector(f.galleryProgress);
    if (!t) {
      this.updateGalleryNavigation();
      return;
    }
    (this.galleryProgress = t),
      t.style.setProperty('--gallery-count', String(e)),
      t.style.setProperty('--gallery-index', String(this.galleryIndex));
    const i = t.querySelector(f.galleryProgressTrack);
    if (i) {
      i.innerHTML = '';
      for (let r = 0; r < e; r++) {
        const s = document.createElement('span');
        (s.className = 'card__gallery-progress-segment'), i.appendChild(s);
      }
    }
    this.updateGalleryNavigation();
  }
  updateGalleryNavigation() {
    var t;
    if (!this.isFiniteGallery) return;
    const e = ((t = this.gallerySlides) == null ? void 0 : t.length) || 0,
      i = this.showingVideo ? !1 : this.galleryIndex > 0 || !!this.videoEl,
      r = this.showingVideo ? e > 0 : this.galleryIndex < e - 1;
    if (document.activeElement === this.galleryPrevBtn && !i && r)
      try {
        this.galleryNextBtn.focus({preventScroll: !0});
      } catch {
        this.galleryNextBtn.focus();
      }
    else if (document.activeElement === this.galleryNextBtn && !r && i)
      try {
        this.galleryPrevBtn.focus({preventScroll: !0});
      } catch {
        this.galleryPrevBtn.focus();
      }
    this.setGalleryControlAvailability(this.galleryPrevBtn, i),
      this.setGalleryControlAvailability(this.galleryNextBtn, r);
  }
  setGalleryControlAvailability(e, t) {
    e && ((e.hidden = !t), (e.disabled = !t));
  }
  getGalleryStepCount() {
    var e;
    return (((e = this.gallerySlides) == null ? void 0 : e.length) || 0) + (this.videoEl ? 1 : 0);
  }
  initSwatches() {
    this.swatchesInitialised ||
      ((this.swatches = this.querySelector(f.swatches)),
      this.swatches &&
        ((this.swatchesInitialised = !0),
        (this.onSwatchClick = this.onSwatchClick.bind(this)),
        (this.onSwatchChange = this.onSwatchChange.bind(this)),
        this.swatches.addEventListener('click', this.onSwatchClick),
        this.swatches.addEventListener('change', this.onSwatchChange)));
  }
  clearConnectedSwatchBusyState() {
    (this.connectedProductPending = !1),
      this.removeAttribute('aria-busy'),
      this.sizeGrid &&
        (this.connectedSizeGridWasInert || this.sizeGrid.removeAttribute('inert'),
        this.connectedSizeGridWasInert && this.sizeGrid.setAttribute('inert', ''),
        this.sizeGrid.removeAttribute('aria-busy')),
      this.sizeOverlayTrigger &&
        ((this.sizeOverlayTrigger.disabled = !!this.connectedSizeTriggerWasDisabled),
        delete this.connectedSizeTriggerWasDisabled),
      delete this.connectedSizeGridWasInert;
  }
  setConnectedSwatchBusyState() {
    this.connectedProductPending ||
      ((this.connectedSizeTriggerWasDisabled = !!(this.sizeOverlayTrigger && this.sizeOverlayTrigger.disabled)),
      (this.connectedSizeGridWasInert = !!(this.sizeGrid && this.sizeGrid.hasAttribute('inert')))),
      (this.connectedProductPending = !0),
      this.setAttribute('aria-busy', 'true'),
      this.sizeOverlayTrigger && (this.sizeOverlayTrigger.disabled = !0),
      this.sizeGrid && (this.sizeGrid.setAttribute('inert', ''), this.sizeGrid.setAttribute('aria-busy', 'true'));
  }
  getConnectedSwatchSelectionSnapshot() {
    var e, t;
    return {
      activeOptionValueId: this.getActiveConnectedSwatchId(),
      checkedOptionValueId:
        ((t =
          (e = this.swatches) == null
            ? void 0
            : e.querySelector('input[type="radio"]:checked[data-option-value-id]')) == null
          ? void 0
          : t.dataset.optionValueId) || '',
    };
  }
  cancelConnectedProductRequest() {
    var e;
    (this.connectedSwatchRequestToken = (this.connectedSwatchRequestToken || 0) + 1),
      (e = this.connectedSwatchAbortController) == null || e.abort(),
      (this.connectedSwatchAbortController = null),
      (this.connectedSwatchNavigationPending = null),
      this.clearConnectedSwatchBusyState();
  }
  onSwatchClick(e) {
    const t = e.target.closest('.product-swatches label');
    if (!t) return;
    if (this.quickAddPending) {
      e.preventDefault(), e.stopPropagation();
      return;
    }
    this.clearQuickAddError();
    const i = this.getConnectedSwatch(t);
    if (i) {
      this.handleConnectedSwatch(e, t, i);
      return;
    }
    e.preventDefault(),
      this.setActiveSwatch(t),
      this.updateCardImageFromSwatch(t),
      this.isSizeOverlayOpen() &&
        (clearTimeout(this.overlayCloseTimer),
        (this.overlayCloseTimer = null),
        this.renderSizeGrid(),
        this.populateSheetSwatches());
  }
  onSwatchChange(e) {
    if (!(e.target instanceof HTMLInputElement)) return;
    const t = e.target.closest('.product-swatches label');
    if (!t) return;
    if (this.quickAddPending) {
      e.preventDefault(), e.stopPropagation();
      return;
    }
    this.clearQuickAddError();
    const i = this.getConnectedSwatch(t);
    i && this.handleConnectedSwatch(e, t, i);
  }
  getConnectedSwatch(e) {
    const t = e.querySelector('input[type="radio"]'),
      i =
        e.hasAttribute('data-combined-listing-option') ||
        (t == null ? void 0 : t.hasAttribute('data-combined-listing-option')),
      n =
        e.hasAttribute('data-product-stitching-option') ||
        (t == null ? void 0 : t.hasAttribute('data-product-stitching-option')),
      r = e.dataset.productUrl || (t == null ? void 0 : t.dataset.productUrl);
    if (!i && !n && !r) return null;
    const s = r || this.dataset.canonicalProductUrl || this.dataset.productUrl;
    return s
      ? {
          productUrl: s,
          optionValueId: e.dataset.optionValueId || (t == null ? void 0 : t.dataset.optionValueId) || '',
          productStitching: n,
        }
      : null;
  }
  getConnectedSwatchDestination(e, t, i = !1) {
    const r = new URL(e, window.location.href);
    return (
      r.searchParams.delete('variant'),
      t && !i ? r.searchParams.set('option_values', t) : r.searchParams.delete('option_values'),
      r
    );
  }
  get isConnectedCardAjaxEnabled() {
    return this.hasAttribute('data-combined-listing-card-section');
  }
  getConnectedProductKey(e) {
    var r;
    const t = new URL(e, window.location.href),
      i = (r = t.pathname.match(/\/products\/[^/]+/i)) == null ? void 0 : r[0];
    return `${t.origin}${i || t.pathname.replace(/\/$/, '') || '/'}`;
  }
  isCurrentConnectedSwatch(e, t) {
    return e.classList.contains(v.swatchActive)
      ? !0
      : this.dataset.productUrl
        ? this.getConnectedProductKey(t.href) === this.getConnectedProductKey(this.dataset.productUrl)
        : !1;
  }
  handleConnectedSwatch(e, t, i) {
    const r = this.getConnectedSwatchDestination(i.productUrl, i.optionValueId, i.productStitching);
    if ((e.preventDefault(), e.stopPropagation(), this.isCurrentConnectedSwatch(t, r))) {
      this.cancelConnectedProductRequest(), this.restoreConnectedSwatchSelection();
      return;
    }
    if (e instanceof MouseEvent && (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey)) {
      e.altKey || this.openConnectedProduct(r.href);
      return;
    }
    this.isConnectedCardAjaxEnabled
      ? this.renderConnectedProduct(r, i.optionValueId, i.productStitching)
      : this.navigateToConnectedProduct(r.href);
  }
  getConnectedCardRequestUrl(e, t, i = !1) {
    const r = new URL(e.href);
    return (
      r.searchParams.delete('variant'),
      t && !i ? r.searchParams.set('option_values', t) : r.searchParams.delete('option_values'),
      r.searchParams.set('section_id', this.dataset.combinedListingCardSection || ae),
      r
    );
  }
  openConnectedProduct(e) {
    window.open(e, '_blank', 'noopener');
  }
  navigateToConnectedProduct(e) {
    window.location.assign(e);
  }
  async renderConnectedProduct(e, t, i = !1) {
    var a;
    const r = this.getConnectedCardRequestUrl(e, t, i),
      s = this.getConnectedSwatchSelectionSnapshot();
    (a = this.connectedSwatchAbortController) == null || a.abort(),
      (this.connectedSwatchAbortController = new AbortController());
    const n = this.connectedSwatchAbortController,
      c = (this.connectedSwatchRequestToken || 0) + 1;
    (this.connectedSwatchRequestToken = c), this.setConnectedSwatchBusyState();
    try {
      const l = await fetch(r, {signal: n.signal});
      if (!l.ok) throw new Error(`Combined Listings card request failed with ${l.status}`);
      const h = await l.text();
      if (c !== this.connectedSwatchRequestToken || !this.isConnected) return;
      const y = new DOMParser().parseFromString(h, 'text/html').querySelector('[data-combined-listing-card-response]');
      if (!y) throw new Error('Combined Listings card response is missing its response root');
      const d = this.parseConnectedProductResponse(y, e, t);
      this.applyConnectedProductResponse(d),
        (this.connectedSwatchAbortController = null),
        this.clearConnectedSwatchBusyState(),
        this.focusConnectedSwatch(t);
    } catch (l) {
      if (c !== this.connectedSwatchRequestToken || l.name === 'AbortError') return;
      (this.connectedSwatchAbortController = null),
        this.clearConnectedSwatchBusyState(),
        this.restoreConnectedSwatchSelection(s.activeOptionValueId || s.checkedOptionValueId),
        window.console.error(l);
    }
  }
  parseConnectedProductResponse(e, t, i) {
    var g;
    const r = e.dataset.productUrl || `${t.pathname}${t.search}`,
      s = new URL(r, window.location.href),
      n = e.querySelector('[data-combined-listing-card-gallery-json]'),
      a = e.querySelector('[data-combined-listing-card-swatches] .product-swatches'),
      c = e.querySelector('[data-combined-listing-card-price]'),
      l = e.querySelector('[data-combined-listing-card-product-json]');
    if (!n || !a || !c) throw new Error('Combined Listings card response is incomplete');
    if (this.hasAttribute('data-quick-add-enabled') && !l)
      throw new Error('Combined Listings card response is missing Quick Add data');
    let o,
      h = null;
    try {
      (o = normalizeCardGalleryData(JSON.parse(n.textContent))), l && (h = JSON.parse(l.textContent));
    } catch {
      throw new Error('Combined Listings card response has invalid JSON data');
    }
    const y = Number(this.dataset.combinedListingCardGalleryLimit);
    Number.isInteger(y) &&
      y > 0 &&
      Object.keys((o == null ? void 0 : o.slidesByColor) || {}).forEach((d) => {
        const w = o.slidesByColor[d];
        Array.isArray(w) && (o.slidesByColor[d] = w.slice(0, y));
      });
    const m = (g = o == null ? void 0 : o.slidesByColor) == null ? void 0 : g[o.defaultColor];
    if (!(o != null && o.defaultColor) || !Array.isArray(m) || !m.length)
      throw new Error('Combined Listings card response has no default gallery slides');
    if (!Array.from(a.querySelectorAll('input[data-option-value-id]')).find((d) => d.dataset.optionValueId === i))
      throw new Error('Combined Listings card response is missing the selected swatch');
    return {
      responseRoot: e,
      canonicalUrl: s,
      optionValueId: i,
      galleryData: o,
      galleryJson: n.textContent,
      quickAddProductJson: h,
      quickAddSizeOptionIndex: l != null && l.hasAttribute('data-size-option-index')
        ? Number(l.dataset.sizeOptionIndex)
        : -1,
      quickAddColorOptionName: (l == null ? void 0 : l.dataset.colorOptionName) || '',
      quickAddColorOptionIndex: l != null && l.hasAttribute('data-color-option-index')
        ? Number(l.dataset.colorOptionIndex)
        : -1,
      responseSwatches: a,
      selectedVariantId: e.dataset.selectedVariantId || '',
      productTitle: e.dataset.productTitle || '',
      productLinkLabel: e.dataset.productLinkLabel || e.dataset.productTitle || '',
      productId: e.dataset.productId || '',
    };
  }
  applyConnectedProductResponse(e) {
    const {
      responseRoot: t,
      canonicalUrl: i,
      optionValueId: r,
      galleryData: s,
      galleryJson: n,
      quickAddProductJson: u,
      quickAddSizeOptionIndex: p,
      quickAddColorOptionName: E,
      quickAddColorOptionIndex: V,
      responseSwatches: a,
      selectedVariantId: c,
      productTitle: l,
      productLinkLabel: o,
      productId: h,
    } = e;
    (this.dataset.canonicalProductUrl = `${i.pathname}${i.search}${i.hash}`),
      (this.dataset.productUrl = this.getCollectionScopedProductUrl(i)),
      h && (this.dataset.productId = h),
      t.dataset.productType != null && (this.dataset.productType = t.dataset.productType),
      t.dataset.productAvailable != null && (this.dataset.productAvailable = t.dataset.productAvailable),
      this.updateConnectedProductContent(t, l, o, h, c),
      this.updateConnectedProductGallery(s, n),
      this.updateConnectedProductSwatches(a, r),
      this.updateConnectedProductQuickAdd(u, p, E, V),
      this.updateConnectedProductLinks(i, c);
  }
  getCollectionScopedProductUrl(e) {
    if (this.dataset.canonicalProductLinks === 'true') return `${e.pathname}${e.search}${e.hash}`;
    var n, a;
    const i =
        (n = new URL(this.dataset.productUrl || e.href, window.location.href).pathname.match(
          /^(.*\/collections\/[^/]+)\/products\/[^/]+/i
        )) == null
          ? void 0
          : n[1],
      r = (a = e.pathname.match(/\/products\/[^/]+/i)) == null ? void 0 : a[0];
    return `${i && r ? `${i}${r}` : e.pathname}${e.search}${e.hash}`;
  }
  updateConnectedProductLinks(e, t) {
    this.querySelectorAll('a[href]').forEach((i) => {
      var a, c;
      if (i.closest('.product-swatches') && !i.classList.contains('product-swatches__more-link')) return;
      const r = new URL(i.href, window.location.href),
        s = (a = r.pathname.match(/^(.*\/collections\/[^/]+)\/products\/[^/]+/i)) == null ? void 0 : a[1],
        n = (c = e.pathname.match(/\/products\/[^/]+/i)) == null ? void 0 : c[0];
      (r.pathname = this.dataset.canonicalProductLinks !== 'true' && s && n ? `${s}${n}` : e.pathname),
        (r.hash = e.hash),
        r.searchParams.delete('option_values'),
        r.searchParams.delete('section_id'),
        t ? r.searchParams.set('variant', t) : r.searchParams.delete('variant'),
        (i.href = `${r.pathname}${r.search}${r.hash}`);
    });
  }
  updateConnectedProductContent(e, t, i, r, s) {
    var a;
    const c = (this.productJson == null ? void 0 : this.productJson.title) || '';
    t &&
      (this.querySelectorAll('.card__heading a').forEach((l) => {
        l.textContent = t;
      }),
      this.querySelectorAll('.card__gallery-link, .card__video a').forEach((l) => {
        l.setAttribute('aria-label', i || t);
      }),
      this.sizeOverlay &&
        (this.sizeOverlay.querySelectorAll('.card__size-sheet-title').forEach((l) => {
          l.textContent = t;
        }),
        this.sizeOverlay.setAttribute('aria-label', t)),
      this.sizeOverlayTrigger &&
        c &&
        this.sizeOverlayTrigger.setAttribute(
          'aria-label',
          (this.sizeOverlayTrigger.getAttribute('aria-label') || '').replace(c, t)
        ));
    const n = (a = this.form) == null ? void 0 : a.querySelector('input[type="hidden"][name="id"]');
    n && (n.value = s),
      r &&
        this.querySelectorAll('rivo-favorite-button[data-product-id]').forEach((c) => {
          c.dataset.productId = r;
        }),
      r &&
        this.querySelectorAll('[data-wishlist-toggle][data-product-id]').forEach((c) => {
          (c.dataset.productId = r),
            (c.dataset.productUrl = this.dataset.canonicalProductUrl),
            t && (c.dataset.productTitle = t),
            c.dispatchEvent(new CustomEvent('elk:wishlist:identity-change', {bubbles: !0}));
        }),
      this.replaceConnectedContent(e, '[data-combined-listing-card-price]', '[data-combined-listing-card-price]'),
      this.updateConnectedProductSheetPrice(e),
      this.replaceConnectedContent(e, '[data-combined-listing-card-badge]', '.card__badge', !0, !1),
      this.replaceConnectedContent(
        e,
        '[data-combined-listing-card-quick-add]',
        '[data-combined-listing-card-quick-add]',
        !0
      ),
      this.updateGalleryArrowContrast();
  }
  updateConnectedProductSheetPrice(e = this) {
    const t = e.querySelector('[data-combined-listing-card-price], .card-information .price'),
      i = this.sizeOverlay == null ? void 0 : this.sizeOverlay.querySelector('[data-size-sheet-price]');
    if (t && i) {
      const r = t.cloneNode(!0);
      r.removeAttribute('data-combined-listing-card-price'), i.replaceChildren(r);
    }
  }
  replaceConnectedContent(e, t, i, r = !1, s = !0) {
    const n = e.querySelector(t);
    if (!n) return;
    (r ? this.querySelectorAll(i) : [this.querySelector(i)]).forEach((c) => {
      if (c)
        if (s) {
          const l = n.cloneNode(!0);
          c.replaceWith(l);
        } else c.innerHTML = n.innerHTML;
    });
  }
  updateConnectedProductGallery(e, t) {
    var r, s;
    if (!this.gallery || !this.cardImage) return;
    this.suppressRolloverPreview({fade: !1}),
      (this.galleryData = normalizeCardGalleryData(e)),
      (this.rolloverSlide = this.galleryData.rollover || null),
      (this.gallerySlidesByColor = {}),
      Object.entries(this.galleryData.slidesByColor || {}).forEach(([n, a]) => {
        this.gallerySlidesByColor[k(n)] = a;
      });
    const i = this.gallery.querySelector(f.galleryJson);
    i && (i.textContent = t),
      (r = this.videoEl) == null || r.remove(),
      (this.videoEl = null),
      (this.showingVideo = !1),
      this.gallery.classList.remove('card__gallery--video-hidden'),
      (s = this.gallery.closest('.card__media')) == null || s.removeAttribute('data-has-video'),
      this.setGalleryForColor(this.galleryData.defaultColor),
      this.connectionActive && this.bindDesktopRollover(),
      this.updateGalleryProgress();
  }
  updateConnectedProductSwatches(e, t) {
    if (!this.swatches) return;
    this.swatches.replaceChildren(...Array.from(e.children, (s) => s.cloneNode(!0)));
    const i = this.findConnectedSwatchControl(t),
      r = i == null ? void 0 : i.closest('label');
    i instanceof HTMLInputElement && (i.checked = !0),
      r &&
        this.swatches.querySelectorAll(`label.${v.swatchActive}`).forEach((s) => {
          s.classList.toggle(v.swatchActive, s === r);
        });
  }
  updateConnectedProductQuickAdd(e, t, i, r) {
    if (!e || !this.hasAttribute('data-quick-add-enabled')) return;
    (this.productJson = e),
      (this.sizeOptionIndex = Number.isInteger(t) && t >= 0 ? t : -1),
      (this.colorOptionName = i || ''),
      (this.colorOptionIndex = Number.isInteger(r) && r >= 0 ? r : -1),
      (this.hasSizeOption = this.sizeOptionIndex >= 0),
      (this.quickAddEnabled = !!(
        this.hasSizeOption &&
        Array.isArray(e.variants) &&
        !e.is_archived &&
        !e['gift_card?']
      ));
    const s = this.querySelector('[data-product-json]');
    s && (s.textContent = JSON.stringify(e)),
      this.isSizeOverlayOpen() && (this.renderSizeGrid(), this.populateSheetSwatches());
  }
  findConnectedSwatchControl(e) {
    var t;
    return (
      Array.from(((t = this.swatches) == null ? void 0 : t.querySelectorAll('[data-option-value-id]')) || []).find(
        (i) => i.dataset.optionValueId === e && i instanceof HTMLInputElement
      ) || null
    );
  }
  getActiveConnectedSwatchId() {
    var e, t;
    return (
      ((t = (e = this.swatches) == null ? void 0 : e.querySelector(`label.${v.swatchActive} [data-option-value-id]`)) ==
      null
        ? void 0
        : t.dataset.optionValueId) || ''
    );
  }
  restoreConnectedSwatchSelection(e = this.getActiveConnectedSwatchId()) {
    const t = this.findConnectedSwatchControl(e),
      i = t == null ? void 0 : t.closest('label');
    !t ||
      !i ||
      ((t.checked = !0),
      this.swatches.querySelectorAll(`label.${v.swatchActive}`).forEach((r) => {
        r.classList.toggle(v.swatchActive, r === i);
      }));
  }
  focusConnectedSwatch(e) {
    const t =
      this.isSizeOverlayOpen() &&
      (this.sizeOverlay == null ? void 0 : this.sizeOverlay.getAttribute('aria-modal')) === 'true' &&
      this.sizeSheetSwatches
        ? Array.from(this.sizeSheetSwatches.querySelectorAll('input[data-option-value-id]')).find(
            (i) => i.dataset.optionValueId === e
          ) || null
        : this.findConnectedSwatchControl(e);
    if (t)
      try {
        t.focus({preventScroll: !0});
      } catch {
        t.focus();
      }
  }
  setActiveSwatch(e) {
    this.swatches.querySelectorAll(`label.${v.swatchActive}`).forEach((i) => {
      i.classList.remove(v.swatchActive);
    }),
      e.classList.add(v.swatchActive);
    const t = e.querySelector('input[type="radio"]');
    t && (t.checked = !0);
  }
  updateCardImageFromSwatch(e) {
    if (!this.cardImage) return;
    const t = e.querySelector('input[type="radio"]'),
      i = t == null ? void 0 : t.value;
    i &&
      (this.showingVideo && this.revealGalleryFromVideo(),
      this.setGalleryForColor(i),
      this.suppressRolloverPreview({fade: !1}));
  }
  initSizeOverlay() {
    var t, i, r, s;
    if (
      this.sizeOverlayInitialised ||
      ((this.sizeOverlayTrigger = this.querySelector(f.sizeOverlayTrigger)), !this.sizeOverlayTrigger)
    )
      return;
    (this.sizeOverlay = this.querySelector(f.sizeOverlay)),
      (this.sizeBackdrop = this.querySelector(f.sizeBackdrop)),
      (this.sizeGrid = this.querySelector(f.sizeGrid)),
      (this.sizeSheetHeader = this.querySelector(f.sizeSheetHeader)),
      (this.sizeSheetSwatches = this.querySelector(f.sizeSheetSwatches)),
      (this.overlayActive = !1),
      (this.mobileOverlayMounted = !1);
    const e = this.querySelector('[data-product-json]');
    if (e) {
      try {
        this.productJson = JSON.parse(e.textContent);
      } catch {
        return;
      }
      if (
        ((this.sizeOverlayInitialised = !0),
        (this.sizeOptionIndex = Number(this.dataset.sizeOptionIndex)),
        (this.colorOptionName = this.dataset.colorOptionName || ''),
        (this.colorOptionIndex = Number(this.dataset.colorOptionIndex)),
        (this.hasSizeOption = Number.isInteger(this.sizeOptionIndex) && this.sizeOptionIndex >= 0),
        this.sizeOverlay)
      ) {
        (this.sizeOverlayParent = this.sizeOverlay.parentElement),
          this.sizeOverlay.setAttribute('role', 'dialog'),
          this.sizeOverlay.removeAttribute('aria-modal'),
          this.sizeOverlay.setAttribute('tabindex', '-1');
        const a =
          ((i = (t = this.sizeOverlay.querySelector('.card__size-sheet-title')) == null ? void 0 : t.textContent) ==
          null
            ? void 0
            : i.trim()) || this.productJson.title || this.sizeOverlayTrigger.getAttribute('aria-label');
        a && this.sizeOverlay.setAttribute('aria-label', a);
      }
      this.sizeBackdrop && (this.sizeBackdropParent = this.sizeBackdrop.parentElement),
        (this.onSizeOverlayTriggerClick = this.onSizeOverlayTriggerClick.bind(this)),
        (this.onDocumentClick = this.onDocumentClick.bind(this)),
        (this.onKeydown = this.onKeydown.bind(this)),
        (this.onViewportChange = this.onViewportChange.bind(this)),
        (this.mobileMediaQuery = window.matchMedia(`(max-width: ${J - 1}px)`)),
        ((r = this.sizeGrid) == null ? void 0 : r.getAttribute('role')) === 'list' &&
          this.sizeGrid.removeAttribute('role'),
        this.sizeOverlayTrigger.addEventListener('click', this.onSizeOverlayTriggerClick),
        this.sizeOverlay && this.sizeOverlay.addEventListener('click', (n) => {
          const a = n.target instanceof Element ? n.target.closest(f.sizeOverlayClose) : null;
          a && (n.preventDefault(), n.stopPropagation(), this.closeSizeOverlay());
        }),
        (s = this.sizeBackdrop) == null || s.addEventListener('click', () => this.closeSizeOverlay());
    }
  }
  initQuickAdd() {
    if (this.quickAddInitialised) return;
    if (
      ((this.quickAddDirectTrigger = this.querySelector(f.quickAddDirect)),
      !this.hasAttribute('data-quick-add-enabled') && !this.quickAddDirectTrigger)
    )
      return;
    const e = this.querySelector('[data-product-json]');
    if (!this.productJson && e)
      try {
        this.productJson = JSON.parse(e.textContent);
      } catch {
        return;
      }
    if (
      !Array.isArray(this.productJson == null ? void 0 : this.productJson.variants) ||
      this.productJson.is_archived ||
      this.productJson['gift_card?']
    )
      return;
    (this.quickAddInitialised = !0),
      (this.quickAddEnabled = !0),
      (this.quickAddMessage = this.querySelector(f.quickAddMessage)),
      (this.quickAddError = this.querySelector(f.quickAddError)),
      (this.colorOptionIndex = Number(this.dataset.colorOptionIndex)),
      (this.onQuickAddSizeClick = (t) => {
        const i = t.target instanceof Element ? t.target.closest('button[data-size-option][data-variant-id]') : null;
        !i || !this.sizeGrid || !this.sizeGrid.contains(i) || i.disabled ||
          (t.preventDefault(), t.stopPropagation(), this.addVariantToCart(i.dataset.variantId, i));
      }),
      (this.onQuickAddDirectClick = (t) => {
        t.preventDefault(),
          t.stopPropagation(),
          !this.quickAddDirectTrigger.disabled &&
            this.addVariantToCart(this.quickAddDirectTrigger.dataset.variantId, this.quickAddDirectTrigger);
      }),
      this.sizeGrid && this.sizeGrid.addEventListener('click', this.onQuickAddSizeClick),
      this.quickAddDirectTrigger &&
        this.quickAddDirectTrigger.addEventListener('click', this.onQuickAddDirectClick);
  }
  initSheetSwipeToDismiss() {
    if (this._sheetSwipeCleanup || !this.sizeSheetHeader || !this.sizeOverlay) return;
    const e = 80,
      t = 0.5;
    let i = 0,
      r = 0,
      s = null,
      n = !1;
    const a = () => {
        (this.sizeOverlay.style.transition = ''), (this.sizeOverlay.style.transform = '');
      },
      c = (y) => {
        var g, d;
        this.quickAddPending ||
          y.isPrimary === !1 ||
          (Number.isFinite(y.button) && y.button !== 0) ||
          y.target.closest('[data-size-overlay-close]') ||
          y.target.closest('[data-size-sheet-swatches]') ||
          (s === null &&
            ((s = y.pointerId),
            (i = y.clientY),
            (r = y.timeStamp),
            (n = !1),
            (d = (g = this.sizeSheetHeader).setPointerCapture) == null || d.call(g, y.pointerId)));
      },
      l = (y) => {
        if (y.pointerId !== s) return;
        const g = y.clientY - i;
        g <= 0 ||
          ((n = !0),
          (this.sizeOverlay.style.transition = 'none'),
          (this.sizeOverlay.style.transform = `translateY(${g}px)`));
      },
      o = (y) => {
        if (y.pointerId !== s) return;
        s = null;
        const g = y.clientY - i,
          d = y.timeStamp - r,
          w = d > 0 ? g / d : 0;
        a(), n && g > 0 && (g > e || w > t) && this.closeSizeOverlay(), (n = !1);
      },
      h = (y) => {
        y.pointerId === s && ((s = null), (n = !1), a());
      };
    this.sizeSheetHeader.addEventListener('pointerdown', c),
      this.sizeSheetHeader.addEventListener('pointermove', l),
      this.sizeSheetHeader.addEventListener('pointerup', o),
      this.sizeSheetHeader.addEventListener('pointercancel', h),
      (this._sheetSwipeCleanup = () => {
        if (s !== null)
          try {
            this.sizeSheetHeader.releasePointerCapture(s);
          } catch {}
        (s = null),
          (n = !1),
          a(),
          this.sizeSheetHeader.removeEventListener('pointerdown', c),
          this.sizeSheetHeader.removeEventListener('pointermove', l),
          this.sizeSheetHeader.removeEventListener('pointerup', o),
          this.sizeSheetHeader.removeEventListener('pointercancel', h),
          (this._sheetSwipeCleanup = null);
      });
  }
  getSelectedColor() {
    var i, r;
    if (!this.colorOptionName) return '';
    if (this.dataset.quickAddColor) return this.dataset.quickAddColor;
    const e = this.form.querySelector(f.formInput(`options[${this.colorOptionName}]`) + ':checked');
    if (e != null && e.value) return e.value;
    const t = (i = this.swatches) == null ? void 0 : i.querySelector('input[type="radio"]:checked');
    return (t == null ? void 0 : t.name) === `options[${this.colorOptionName}]`
      ? t.value
      : ((r = this.galleryData) == null ? void 0 : r.defaultColor) && !this.quickAddEnabled
        ? this.galleryData.defaultColor
        : '';
  }
  getVariantsForSelectedColor() {
    const e = k(this.getSelectedColor()),
      t =
        Number.isInteger(this.colorOptionIndex) && this.colorOptionIndex >= 0
          ? this.colorOptionIndex
          : this.colorOptionName
            ? 0
            : -1,
      i = t === this.sizeOptionIndex ? -1 : t;
    return this.productJson.variants.filter((t) =>
      e && i >= 0 ? k(t.options[i]) === e : !0
    );
  }
  getSizeValuesForSelectedColor() {
    if (!this.hasSizeOption) return [];
    const e = new Set();
    return (
      this.getVariantsForSelectedColor().forEach((t) => {
        const i = t.options[this.sizeOptionIndex];
        i && e.add(i);
      }),
      Array.from(e)
    );
  }
  getVariantForSize(e) {
    return this.getVariantsForSize(e)[0];
  }
  getVariantsForSize(e) {
    return this.getVariantsForSelectedColor().filter((t) => t.options[this.sizeOptionIndex] === e);
  }
  getVariantUrl(e) {
    const t = this.dataset.productUrl || `/products/${this.productJson.handle || ''}`,
      i = new URL(t, window.location.origin);
    return e != null && e.id && i.searchParams.set('variant', String(e.id)), `${i.pathname}${i.search}${i.hash}`;
  }
  renderSizeGrid() {
    if (!this.sizeGrid) return;
    const e = this.getSizeValuesForSelectedColor();
    (this.sizeGrid.innerHTML = ''),
      e.length &&
        e.forEach((t) => {
          var n;
          const i = this.getVariantsForSize(t),
            r = i[0],
            s = !!this.quickAddEnabled && i.length === 1,
            a = document.createElement(s ? 'button' : 'a');
          (a.className = 'card__size-option button'), (a.dataset.sizeOption = '');
          s ? (a.type = 'button') : ((a.href = this.getVariantUrl(i.length === 1 ? r : null)), (a.dataset.quickAddFallback = ''));
          const c = document.createElement('span');
          if (
            ((c.className = 'card__size-option-label'),
            (c.textContent = t),
            a.appendChild(c),
            s && !(r != null && r.available))
          )
            a.classList.add(v.sizeOptionDisabled),
              (a.disabled = !0),
              a.setAttribute('aria-label', `${t} — ${(window.variantStrings || {}).soldOut || 'Sold out'}`);
          else if ((n = r == null ? void 0 : r.custom) != null && n.is_low_stock) {
            a.classList.add(v.sizeOptionLowStock);
            const l = document.createElement('span');
            (l.className = 'card__size-option-stock'),
              (l.textContent = `${r.inventory_quantity} left!`),
              a.appendChild(l);
          }
          s && r != null && r.available &&
            a.setAttribute(
              'aria-label',
              `${(window.variantStrings || {}).addToCart || 'Add to cart'} — ${this.productJson.title}, ${t}`
            ),
            r != null && r.id && (a.dataset.variantId = String(r.id)),
            this.sizeGrid.appendChild(a);
        });
  }
  addVariantToCart(e, t) {
    const i = Number(e),
      r = this.productJson.variants.find((n) => Number(n.id) === i);
    if (!Number.isFinite(i) || !(r != null && r.available) || this.quickAddPending || this.connectedProductPending)
      return;
    (this.quickAddPending = !0),
      this.clearQuickAddError(),
      this.quickAddMessage && (this.quickAddMessage.textContent = ''),
      this.setQuickAddBusyState(!0, t);
    const drawerOwner = this.closest('wishlist-drawer, account-drawer');
    const s = () => this.submitVariantToCart(i, t, drawerOwner),
      n = quickAddQueue.then(s, s);
    return (quickAddQueue = n.catch(() => {})), n;
  }
  async submitVariantToCart(e, t, drawerOwner = this.closest('wishlist-drawer, account-drawer')) {
    var i;
    const n = new FormData();
    n.append('id', String(e)), n.append('quantity', '1');
    const a = document.querySelector('cart-notification') || document.querySelector('cart-drawer'),
      c = document.querySelector('.cart-drawer .overlay');
    a &&
      (typeof a.getSectionsToRender == 'function' &&
        n.append(
          'sections',
          a
            .getSectionsToRender()
            .map((o) => o.id || o.section)
            .filter(Boolean)
        ),
      n.append('sections_url', window.location.pathname),
      typeof a.setActiveElement == 'function' && a.setActiveElement(this.sizeOverlayTrigger || t)),
      c && (c.style.display = 'block');
    let l = !1,
      o = !1,
      h = !1,
      y = '';
    try {
      const g = await fetch(((i = window.routes) == null ? void 0 : i.cart_add_url) || '/cart/add.js', {
          method: 'POST',
          headers: {Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest'},
          body: n,
        });
      o = g.ok;
      const d = await g.json();
      if (!g.ok || d.status) {
        o = !1;
        y = d.description || d.message || '';
        throw new Error(y);
      }
      (l = !0),
        this.isConnected &&
          this.isSizeOverlayOpen() &&
          this.closeSizeOverlay({immediate: !0, restoreFocus: !1, force: !0});
      const cartAddTarget = !this.isConnected && drawerOwner?.isConnected ? drawerOwner : this;
      cartAddTarget.dispatchEvent(new CustomEvent('elk:product-card:cart-add', {bubbles: !0, detail: {cart: a, card: this}}));
      a && a.classList.contains('is-empty') && a.classList.remove('is-empty');
      if (a && typeof a.renderContents == 'function') {
        !this.isConnected &&
          !drawerOwner?.isConnected &&
          typeof a.setActiveElement == 'function' &&
          a.setActiveElement(document.querySelector('#cart-icon-bubble')),
          a.renderContents(d),
          this.hideCartDrawerOverlay(),
          a.matches('cart-drawer') && this.refreshCartRecommendations();
      } else {
        (h = !0), this.hideCartDrawerOverlay();
        this.redirectToCart();
        return;
      }
      this.isConnected &&
        this.quickAddMessage &&
        (this.quickAddMessage.textContent = this.quickAddMessage.dataset.successMessage || 'Item added to your cart');
    } catch (g) {
      if (l || o) {
        (h = !0), this.hideCartDrawerOverlay(), window.console.error(g), this.redirectToCart();
        return;
      }
      this.showQuickAddError(y || (window.cartStrings || {}).error || 'Unable to add this item to your cart.'),
        this.hideCartDrawerOverlay();
    } finally {
      (this.quickAddPending = !1),
        !h && this.setQuickAddBusyState(!1, t);
    }
  }
  setQuickAddBusyState(e, t) {
    const i = !!(t && this.sizeGrid && this.sizeGrid.contains(t));
    t &&
      (!i && (t.disabled = e),
      t.toggleAttribute('aria-busy', e),
      t.classList.toggle('loading', e));
    if (!this.sizeOverlay) return;
    this.sizeOverlay.toggleAttribute('aria-busy', e),
      this.sizeOverlay.querySelectorAll(f.sizeOverlayClose).forEach((r) => {
        r.disabled = e;
      }),
      this.sizeGrid &&
        this.sizeGrid.querySelectorAll('button[data-size-option]').forEach((r) => {
          e
            ? ((r.dataset.quickAddWasDisabled = r.disabled ? 'true' : 'false'), (r.disabled = !0))
            : ((r.disabled = r.dataset.quickAddWasDisabled === 'true'), delete r.dataset.quickAddWasDisabled);
        });
  }
  hideCartDrawerOverlay() {
    const e = document.querySelector('.cart-drawer .overlay');
    e && (e.style.display = 'none');
  }
  refreshCartRecommendations() {
    var e;
    const t = (e = window.theme) == null ? void 0 : e.utils;
    if (typeof (t == null ? void 0 : t.getRandomIdProduct) != 'function') return;
    try {
      t.getRandomIdProduct();
    } catch (i) {
      window.console.error(i);
    }
  }
  redirectToCart() {
    window.location.assign((window.routes || {}).cart_url || '/cart');
  }
  clearQuickAddError() {
    this.quickAddError && ((this.quickAddError.textContent = ''), (this.quickAddError.hidden = !0));
  }
  showQuickAddError(e) {
    this.quickAddError && ((this.quickAddError.textContent = e), (this.quickAddError.hidden = !1));
  }
  ensureSizeSheetHeader() {
    if (!this.sizeSheetHeader || this.sizeSheetHeader.querySelector(f.sizeOverlayClose)) return;
    const close = document.createElement('button'),
      info = document.createElement('div'),
      title = document.createElement('p'),
      price = document.createElement('div'),
      swatches = document.createElement('div');
    close.type = 'button';
    close.className = 'card__size-sheet-close';
    close.setAttribute('data-size-overlay-close', '');
    close.setAttribute('aria-label', this.sizeSheetHeader.dataset.closeLabel || 'Close');
    close.innerHTML = '<svg aria-hidden="true" focusable="false" role="presentation" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M17.25 17.25L6.75 6.75" stroke="#101010" stroke-linecap="round" stroke-linejoin="round"/><path d="M17.25 6.75L6.75 17.25" stroke="#101010" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    info.className = 'card__size-sheet-info';
    title.className = 'card__size-sheet-title';
    title.textContent = this.querySelector('.card__heading a')?.textContent?.trim() || this.productJson?.title || '';
    price.className = 'card__size-sheet-price';
    price.setAttribute('data-size-sheet-price', '');
    swatches.className = 'card__size-sheet-swatches';
    swatches.setAttribute('data-size-sheet-swatches', '');
    info.append(title, price, swatches);
    this.sizeSheetHeader.append(close, info);
    this.sizeSheetSwatches = swatches;
    this.updateConnectedProductSheetPrice();
    this.initSheetSwipeToDismiss();
  }
  populateSheetSwatches() {
    if (!this.sizeSheetSwatches || ((this.sizeSheetSwatches.innerHTML = ''), !this.colorOptionName || !this.swatches))
      return;
    const e = document.createElement('ul');
    (e.className = 'product-swatches small card__size-sheet-swatches-list'),
      this.swatches.querySelectorAll('li').forEach((t) => {
        const i = t.querySelector('label');
        if (!i) {
          e.appendChild(t.cloneNode(!0));
          return;
        }
        const r = document.createElement('li'),
          s = i.cloneNode(!0);
        s.querySelectorAll('input').forEach((n) => {
          n.removeAttribute('name');
        }),
          r.appendChild(s),
          e.appendChild(r),
          s.addEventListener('click', (n) => {
            n.preventDefault(), n.stopPropagation();
            if (this.quickAddPending) return;
            this.clearQuickAddError();
            const a = this.getConnectedSwatch(i);
            if (a) {
              this.handleConnectedSwatch(n, i, a);
              return;
            }
            const c = i.querySelector('input[type="radio"]');
            c && ((c.checked = !0), c.dispatchEvent(new Event('change', {bubbles: !0}))),
              this.setActiveSwatch(i),
              this.updateCardImageFromSwatch(i),
              this.renderSizeGrid(),
              this.populateSheetSwatches();
          });
      }),
      this.sizeSheetSwatches.appendChild(e);
  }
  onSizeOverlayTriggerClick(e) {
    if (this.connectedProductPending) {
      e.preventDefault(), e.stopPropagation();
      return;
    }
    if ((e.preventDefault(), e.stopPropagation(), this.isSizeOverlayOpen())) {
      this.closeSizeOverlay();
      return;
    }
    this.openSizeOverlay();
  }
  bindOverlayDismissListeners() {
    this.overlayDismissBound ||
      (document.addEventListener('click', this.onDocumentClick),
      document.addEventListener('keydown', this.onKeydown),
      (this.overlayDismissBound = !0));
  }
  unbindOverlayDismissListeners() {
    this.overlayDismissBound &&
      (document.removeEventListener('click', this.onDocumentClick),
      document.removeEventListener('keydown', this.onKeydown),
      (this.overlayDismissBound = !1));
  }
  openSizeOverlay() {
    var t, i, r;
    if (!this.sizeOverlay || this.overlayActive || this.connectedProductPending) return;
    this.suppressRolloverPreview({fade: !1}), this.clearQuickAddError();
    const e = Array.from(document.querySelectorAll('product-card')).filter((s) => {
      var n;
      return s !== this && !!((n = s.isSizeOverlayOpen) != null && n.call(s));
    });
    if (
      (e.forEach((s) => s.closeSizeOverlay({immediate: !0, restoreFocus: !1})),
      e.some((s) => s.isSizeOverlayOpen()))
    )
      return;
    (this.overlayActive = !0),
      (this.overlayReturnFocus =
        document.activeElement instanceof HTMLElement && document.activeElement !== document.body
          ? document.activeElement
          : this.sizeOverlayTrigger),
      clearTimeout(this.overlayFinishTimer),
      cancelAnimationFrame(this.overlayOpenFrame),
      cancelAnimationFrame(this.overlayVisibleFrame),
      cancelAnimationFrame(this.overlayFocusFrame),
      this.overlayTransitionHandler &&
        (this.sizeOverlay.removeEventListener('transitionend', this.overlayTransitionHandler),
        (this.overlayTransitionHandler = null));
    const s = this.isMobileViewport();
    s ? this.sizeOverlay.setAttribute('aria-modal', 'true') : this.sizeOverlay.removeAttribute('aria-modal'),
      s || (this.sizeOverlayTrigger.hidden = !0),
      this.bindOverlayDismissListeners(),
      this.renderSizeGrid(),
      s
        ? (this.ensureSizeSheetHeader(),
          this.populateSheetSwatches(),
          (t = this.sizeSheetHeader) == null || t.removeAttribute('hidden'),
          this.mountMobileOverlay(),
          this.isolateBackground())
        : (i = this.sizeSheetHeader) == null || i.setAttribute('hidden', ''),
      this.sizeOverlay.removeAttribute('hidden'),
      s && ((r = this.sizeBackdrop) == null || r.removeAttribute('hidden')),
      this.classList.add(v.cardSizeOverlayOpen),
      this.sizeOverlayTrigger.setAttribute('aria-expanded', 'true'),
      (this.overlayOpenFrame = requestAnimationFrame(() => {
        this.overlayVisibleFrame = requestAnimationFrame(() => {
          var n;
          this.overlayActive &&
            (this.sizeOverlay.classList.add(v.overlayOpen),
            s && ((n = this.sizeBackdrop) == null || n.classList.add(v.backdropOpen)),
            (this.overlayFocusFrame = requestAnimationFrame(() => {
              this.overlayActive && this.focusInitialOverlayControl();
            })));
        });
      }));
  }
  mountMobileOverlay() {
    if (!this.isMobileViewport() || this.mobileOverlayMounted) return;
    const wishlist = this.closest('wishlist-drawer, account-drawer');
    for (const element of [this.sizeBackdrop, this.sizeOverlay]) {
      if (!element) continue;
      element.toggleAttribute('data-wishlist-size-sheet', wishlist?.matches('wishlist-drawer') || false);
      element.toggleAttribute('data-drawer-size-sheet', Boolean(wishlist));
      document.body.appendChild(element);
    }
    document.body.classList.add('card-size-sheet-open');
    this.mobileOverlayMounted = !0;
  }
  unmountMobileOverlay() {
    this.mobileOverlayMounted &&
      (this.sizeBackdrop?.removeAttribute('data-drawer-size-sheet'),
      this.sizeOverlay?.removeAttribute('data-drawer-size-sheet'),
      this.sizeBackdrop?.removeAttribute('data-wishlist-size-sheet'),
      this.sizeOverlay?.removeAttribute('data-wishlist-size-sheet'),
      this.sizeBackdrop && this.sizeBackdropParent && this.sizeBackdropParent.appendChild(this.sizeBackdrop),
      this.sizeOverlay && this.sizeOverlayParent && this.sizeOverlayParent.appendChild(this.sizeOverlay),
      document.body.classList.remove('card-size-sheet-open'),
      (this.mobileOverlayMounted = !1));
  }
  isMobileViewport() {
    var e;
    return (
      ((e = this.mobileMediaQuery) == null ? void 0 : e.matches) ?? window.matchMedia(`(max-width: ${J - 1}px)`).matches
    );
  }
  onViewportChange() {
    this.removeRolloverPreview(),
      (this.rolloverHoverActive = !1),
      (this.rolloverSuppressedForHover = !1),
    this.overlayActive
      ? this.closeSizeOverlay({immediate: !0})
      : (this.unmountMobileOverlay(), this.releaseBackgroundIsolation());
  }
  closeSizeOverlay({immediate: e = !1, restoreFocus: t = !0, force: n = !1} = {}) {
    var r, s;
    if (!this.sizeOverlay || !this.isSizeOverlayOpen() || (this.quickAddPending && !n)) return;
    clearTimeout(this.overlayCloseTimer),
      (this.overlayCloseTimer = null),
      clearTimeout(this.overlayFinishTimer),
      cancelAnimationFrame(this.overlayOpenFrame),
      cancelAnimationFrame(this.overlayVisibleFrame),
      cancelAnimationFrame(this.overlayFocusFrame),
      (this.overlayActive = !1),
      this.sizeOverlay.classList.remove(v.overlayOpen),
      (r = this.sizeBackdrop) == null || r.classList.remove(v.backdropOpen),
      this.classList.remove(v.cardSizeOverlayOpen),
      (s = this.sizeOverlayTrigger) == null || s.setAttribute('aria-expanded', 'false'),
      this.sizeOverlayTrigger && (this.sizeOverlayTrigger.hidden = !1),
      this.unbindOverlayDismissListeners();
    const i = () => {
      var n, a;
      this.overlayTransitionHandler &&
        (this.sizeOverlay.removeEventListener('transitionend', this.overlayTransitionHandler),
        (this.overlayTransitionHandler = null)),
        clearTimeout(this.overlayFinishTimer),
        (this.overlayFinishTimer = null),
        !this.overlayActive &&
          (this.sizeOverlay.setAttribute('hidden', ''),
          this.sizeOverlay.removeAttribute('aria-modal'),
          (n = this.sizeBackdrop) == null || n.setAttribute('hidden', ''),
          this.unmountMobileOverlay(),
          this.releaseBackgroundIsolation(),
          t &&
            (a = this.overlayReturnFocus) != null &&
            a.isConnected &&
            this.overlayReturnFocus.focus({preventScroll: !0}),
          (this.overlayReturnFocus = null));
    };
    if (
      ((this.overlayTransitionHandler = (n) => {
        n.target !== this.sizeOverlay || n.propertyName !== 'transform' || i();
      }),
      e)
    ) {
      i();
      return;
    }
    this.sizeOverlay.addEventListener('transitionend', this.overlayTransitionHandler),
      (this.overlayFinishTimer = window.setTimeout(i, se + 50));
  }
  isSizeOverlayOpen() {
    return !!this.overlayActive;
  }
  focusInitialOverlayControl() {
    var r, s;
    const e = (r = this.sizeOverlay) == null ? void 0 : r.querySelector(`${f.sizeOverlayClose}:not([disabled])`),
      t = (s = this.sizeOverlay) == null ? void 0 : s.querySelector(`${f.sizeOption}:not([disabled])`),
      i = e && !e.closest('[hidden]') ? e : t || this.sizeOverlay;
    i == null || i.focus({preventScroll: !0});
  }
  getOverlayFocusableElements() {
    return this.sizeOverlay
      ? Array.from(
          this.sizeOverlay.querySelectorAll(
            'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
          )
        ).filter((e) => !e.closest('[hidden]') && e.getAttribute('aria-hidden') !== 'true')
      : [];
  }
  isolateBackground() {
    !this.mobileOverlayMounted ||
      this.backgroundInertElements ||
      ((this.backgroundInertElements = Array.from(document.body.children).filter(
        (e) => e instanceof HTMLElement && e !== this.sizeOverlay && e !== this.sizeBackdrop && !e.hasAttribute('inert')
      )),
      this.backgroundInertElements.forEach((e) => e.setAttribute('inert', '')));
  }
  releaseBackgroundIsolation() {
    var e;
    (e = this.backgroundInertElements) == null || e.forEach((t) => t.removeAttribute('inert')),
      (this.backgroundInertElements = null);
  }
  onDocumentClick(e) {
    var i;
    if (!this.isSizeOverlayOpen()) return;
    const t = e.target;
    t instanceof Element &&
      (((i = this.sizeOverlay) != null && i.contains(t)) ||
        (this.contains(t) && (t.closest(f.sizeOverlayTrigger) || t.closest(f.swatches))) ||
        this.closeSizeOverlay());
  }
  onKeydown(e) {
    var n, a, c, l;
    if (!this.isSizeOverlayOpen()) return;
    if (e.key === 'Escape') {
      e.preventDefault(), this.closeSizeOverlay();
      return;
    }
    if (e.key !== 'Tab' || ((n = this.sizeOverlay) == null ? void 0 : n.getAttribute('aria-modal')) !== 'true') return;
    const t = this.getOverlayFocusableElements();
    if (!t.length) {
      e.preventDefault(), (a = this.sizeOverlay) == null || a.focus();
      return;
    }
    const i = t[0],
      r = t[t.length - 1],
      s = document.activeElement;
    e.shiftKey && (s === i || !((c = this.sizeOverlay) != null && c.contains(s)))
      ? (e.preventDefault(), r.focus())
      : !e.shiftKey &&
        (s === r || !((l = this.sizeOverlay) != null && l.contains(s))) &&
        (e.preventDefault(), i.focus());
  }
}
window.addEventListener('pageshow', () => {
  document.querySelectorAll('product-card[aria-busy="true"]').forEach((S) => {
    var e, t;
    (e = S.cancelConnectedProductRequest) == null || e.call(S),
      (t = S.restoreConnectedSwatchSelection) == null || t.call(S);
  });
});
customElements.get('product-card') || customElements.define('product-card', oe);
